import { toast } from "react-toastify";
import { call, put, takeLatest, select, takeEvery } from "redux-saga/effects";
import { actions } from "..";
import {
  checkArray,
  checkNull,
  downloadFileFromUrl,
  makeAllObjToArr,
} from "../../helpers";
import { settingServices } from "../../services";
import {
  accountManagementData,
  accountSettingData,
  addClusterdetails,
  changeSettingValue,
  clearCompanySettingData,
  codeListData,
  companySettingData,
  toggleCompanyNameModal,
  toggleSettingDocModal,
  userLogout,
  showAlert,
  getMerchantUserList,
  getPermissionGroupList,
  getFinanceGeneralSettings,
  getPublicHoliday,
  getFinanceForecastSettings,
  getRoomsLayout,
} from "../actions";
import { showNotificationWithTimeout } from "../actions/toastActions";
import * as actionTypes from "../actionTypes";

let errMsg = "Something went wrong!";

function* getAccountSetting(action) {
  const res = yield call(settingServices.getAccountSetting, action?.query);
  console.log("ACCOUNT_SETTING_DETAILS", res);
  if (res) {
    if (res?.status) {
      console.log("ACCOUNT_SETTING_DETAILS", res?.data);
      yield put({
        type: actionTypes.ACCOUNT_SETTING_DETAILS_SUCCEEDED,
        payload: {
          account: res?.data,
        },
      });
    } else {
      yield put({
        type: actionTypes.ACCOUNT_SETTING_DETAILS_FAILED,
        payload: {
          account: null,
        },
      });
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
}

function* saveUploadAccLogo(action) {
  const res = yield call(settingServices.saveUploadAccLogo, action?.payload);
  if (res) {
    if (!res?.status) {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  if (action.fromType == "account") {
    yield put(accountSettingData());
  } else if (action.fromType == "finance") {
    yield put(getFinanceGeneralSettings());
  }
}

function* saveUploadAccDocument(action) {
  yield put(changeSettingValue("is_modal_loading", true));
  const res = yield call(
    settingServices.saveUploadAccDocument,
    action?.payload,
    action?.query
  );
  if (res) {
    if (res?.status) {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? ""}`, "success")
      );
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  if (action.fromType == "companySettings") {
    yield put(companySettingData(action?.merchantInfoId));
  } else if (action.fromType == "finance") {
    yield put(getFinanceGeneralSettings());
  }
  yield put(changeSettingValue("is_modal_loading", false));
  yield put(toggleSettingDocModal(false));
}
function* deleteAccountingDocument(action) {
  const res = yield call(
    settingServices.deleteAccountingDocument,
    action?.payload
  );
  if (res) {
    if (res?.status) {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? ""}`, "success")
      );
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  if (action.fromType == "companySettings") {
    yield put(companySettingData(action?.merchantInfoId));
  } else if (action.fromType == "finance") {
    yield put(getFinanceGeneralSettings());
  }
}
function* updateAccPeriodStatus(action) {
  const res = yield call(
    settingServices.updateAccPeriodStatus,
    action?.payload
  );
  if (res) {
    if (res?.status) {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? ""}`, "success")
      );
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  if (action.fromType == "companySettings") {
    yield put(companySettingData(action?.merchantInfoId));
  } else if (action.fromType == "finance") {
    yield put(getFinanceGeneralSettings());
  }
}

function* getCompanySetting(action) {
  const res = yield call(settingServices.getCompanySetting, action?.merchantId);
  console.log("COMPANY_SETTING_DETAILS", res);
  if (res) {
    if (res?.status) {
      yield put({
        type: actionTypes.COMPANY_SETTING_DETAILS_SUCCEEDED,
        payload: {
          company_setting: res?.data,
        },
      });
    } else {
      yield put(clearCompanySettingData());
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
}

function* saveScheduleCompanyName(action) {
  yield put(changeSettingValue("is_modal_loading", true));
  const res = yield call(
    settingServices.saveScheduleCompanyName,
    action?.payload
  );
  if (res) {
    if (res?.status) {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? ""}`, "success")
      );
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(companySettingData(action?.merchantInfoId));
  yield put(changeSettingValue("is_modal_loading", false));
  yield put(toggleCompanyNameModal(false));
}

function* getScheduleCompanyName(action) {
  yield put(changeSettingValue("is_loading", true));
  const company_setting = yield select(
    (state) => state?.settingReducer?.company_setting
  );
  const res = yield call(
    settingServices.getScheduleCompanyName,
    action?.merchantId
  );
  console.log("GET_COMPANY_NAME", res);
  if (res) {
    if (res?.status) {
      yield put({
        type: actionTypes.COMPANY_SETTING_DETAILS_SUCCEEDED,
        payload: {
          company_setting: {
            ...company_setting,
            company_name_details: res?.data?.data ?? null,
          },
        },
      });
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("is_loading", false));
  yield put(toggleCompanyNameModal(true));
}

function* getCodeList(action) {
  const res = yield call(settingServices.getCodeList, action?.query);
  if (res) {
    if (res?.status) {
      yield put({
        type: actionTypes.CODE_LIST_DETAILS_SUCCEEDED,
        payload: {
          code_list: res?.data?.code_list ?? [],
        },
      });
    } else {
      yield put({
        type: actionTypes.CODE_LIST_DETAILS_FAILED,
        payload: {
          code_list: null,
        },
      });
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
}

function* saveCodeData(action) {
  yield put(changeSettingValue("is_add_btn_loading", true));
  const res = yield call(settingServices.saveCodeData, action?.query);
  if (res) {
    if (!res?.status) {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
    yield put(codeListData());
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("is_add_btn_loading", false));
}

function* deleteCodeDetails(action) {
  yield put(changeSettingValue("is_delete_btn_loading", true));
  yield put(changeSettingValue("is_delete_btn_id", action?.payload?.id ?? ""));
  const res = yield call(settingServices.deleteCodeDetails, action?.payload);
  if (res) {
    if (res?.status) {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? "Success"}`, "success")
      );
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
    yield put(codeListData());
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("is_delete_btn_loading", false));
  yield put(changeSettingValue("is_delete_btn_id", ""));
}

function* getAccountManagement(action) {
  const res = yield call(settingServices.getAccountManagement, action?.query);
  console.log("ACCOUNT_MANAGEMENT_DETAILS", res);
  if (res) {
    if (res?.status) {
      console.log("ACCOUNT_MANAGEMENT_DETAILS", res?.data);
      yield put({
        type: actionTypes.ACCOUNT_MANAGEMENT_DETAILS_SUCCEEDED,
        payload: {
          account_management: res?.data,
        },
      });
    } else {
      yield put({
        type: actionTypes.ACCOUNT_MANAGEMENT_DETAILS_FAILED,
        payload: {
          account_management: null,
        },
      });
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
}

function* saveAccountManagementData(action) {
  const user_details = yield select(
    (state) => state?.authReducer?.user_details
  );
  yield put(changeSettingValue("is_add_btn_loading", true));
  const res = yield call(
    settingServices.saveAccountManagementData,
    action?.payload
  );
  if (res) {
    if (res?.status) {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? "Success"}`, "success")
      );
      if (res?.data) {
        yield put(changeSettingValue("account_management", res?.data));
      }
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
      yield put(
        accountManagementData(
          user_details?.user?.merchant_id,
          user_details?.user?.id
        )
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("is_add_btn_loading", false));
}

function* updateAccountAdminData(action) {
  const user_details = yield select(
    (state) => state?.authReducer?.user_details
  );
  yield put(changeSettingValue("is_accAdmin_modal_loading", true));
  const res = yield call(
    settingServices.updateAccountAdminData,
    action?.payload
  );
  if (res) {
    if (res?.status) {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? "Success"}`, "success")
      );
      if (res?.data) {
        yield put(changeSettingValue("account_management", res?.data));
      }
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
      yield put(
        accountManagementData(
          user_details?.user?.merchant_id,
          user_details?.user?.id
        )
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("is_accAdmin_modal_loading", false));
  yield put(changeSettingValue("accAdminModal", false));
}
function* updatePlanCostData(action) {
  const user_details = yield select(
    (state) => state?.authReducer?.user_details
  );
  yield put(changeSettingValue("is_changePlan_modal_loading", true));
  const res = yield call(settingServices.updatePlanCostData, action?.payload);
  if (res) {
    if (res?.status) {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? "Success"}`, "success")
      );
      if (res?.data?.data) {
        yield put(changeSettingValue("account_management", res?.data?.data));
      }
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
      yield put(
        accountManagementData(
          user_details?.user?.merchant_id,
          user_details?.user?.id
        )
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("is_changePlan_modal_loading", false));
  yield put(changeSettingValue("changePlanModal", false));
}
function* updatePlanTopupData(action) {
  const user_details = yield select(
    (state) => state?.authReducer?.user_details
  );
  yield put(changeSettingValue("is_changeTopup_modal_loading", true));
  const res = yield call(settingServices.updatePlanTopupData, action?.payload);
  if (res) {
    if (res?.status) {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? "Success"}`, "success")
      );
      if (res?.data?.data) {
        yield put(changeSettingValue("account_management", res?.data?.data));
      }
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
      yield put(
        accountManagementData(
          user_details?.user?.merchant_id,
          user_details?.user?.id
        )
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("is_changeTopup_modal_loading", false));
  yield put(changeSettingValue("changeTopupModal", false));
}
function* updatePosCountData(action) {
  const user_details = yield select(
    (state) => state?.authReducer?.user_details
  );
  yield put(changeSettingValue("is_changePosCount_modal_loading", true));
  const res = yield call(settingServices.updatePosCountData, action?.payload);
  if (res) {
    if (res?.status) {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? "Success"}`, "success")
      );
      if (res?.data?.data) {
        yield put(changeSettingValue("account_management", res?.data?.data));
      }
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
      yield put(
        accountManagementData(
          user_details?.user?.merchant_id,
          user_details?.user?.id
        )
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("is_changePosCount_modal_loading", false));
  yield put(changeSettingValue("changePosCountModal", false));
}

function* getOwnerSubAccData(action) {
  yield put(changeSettingValue("is_save_payment_loading", true));
  const account_management = yield select(
    (state) => state?.settingReducer?.account_management
  );
  const res = yield call(settingServices.getOwnerSubAccData, action?.query);
  if (res) {
    if (res?.status) {
      let newSubArr = [];
      if (checkArray(res?.data?.subAccounts)) {
        newSubArr = res?.data?.subAccounts;
      }
      yield put(
        changeSettingValue("account_management", {
          ...account_management,
          subAccounts: newSubArr,
        })
      );
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("is_save_payment_loading", false));
}

function* savePaymentInfoData(action) {
  const user_details = yield select(
    (state) => state?.authReducer?.user_details
  );
  yield put(changeSettingValue("is_save_payment_loading", true));
  const res = yield call(settingServices.savePaymentInfoData, action?.payload);
  if (res) {
    if (res?.status) {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? "Success"}`, "success")
      );
      if (res?.data) {
        yield put(changeSettingValue("account_management", res?.data));
      }
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
      yield put(
        accountManagementData(
          user_details?.user?.merchant_id,
          user_details?.user?.id
        )
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("is_save_payment_loading", false));
}
function* cancelAccountData(action) {
  yield put(changeSettingValue("is_cancel_account_loading", true));
  const res = yield call(settingServices.cancelAccountData, action?.payload);
  if (res) {
    if (res?.status) {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? "Success"}`, "success")
      );
      yield put(userLogout());
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("is_cancel_account_loading", false));
  yield put(changeSettingValue("cancelAccModal", false));
}

function* getInvoiceListData(action) {
  const res = yield call(settingServices.getInvoiceListData, action?.payload);
  console.log("GET_INVOICE_LIST", res);
  if (res) {
    if (res?.status) {
      console.log("GET_INVOICE_LIST", res?.data);
      yield put({
        type: actionTypes.GET_INVOICE_LIST_SUCCEEDED,
        payload: {
          invoice_list: res?.data?.invoices ?? [],
        },
      });
    } else {
      yield put({
        type: actionTypes.GET_INVOICE_LIST_FAILED,
        payload: {
          invoice_list: [],
        },
      });
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
}

function* getInvoiceDetailsData(action) {
  yield put(changeSettingValue("is_invoice_detail_modal_loading", true));
  const res = yield call(settingServices.getInvoiceDetailsData, action?.query);
  if (res) {
    if (res?.status) {
      let newInvoice = null;
      if (checkNull(res?.data, false)) {
        newInvoice = res?.data;
      }
      yield put(changeSettingValue("invoice_detail", newInvoice));
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("is_invoice_detail_modal_loading", false));
  if (checkNull(res?.data, false)) {
    yield put(changeSettingValue("invoiceDetailModal", true));
  }
}

// user management

function* getUserManagementData(action) {
  const res = yield call(settingServices.getUserManagementData, action?.query);
  console.log("GET_USER_MANAGE_DETAILS", res);
  if (res) {
    if (res?.status) {
      console.log("GET_USER_MANAGE_DETAILS", res?.data);
      yield put({
        type: actionTypes.GET_USER_MANAGE_DETAILS_SUCCEEDED,
        payload: {
          user_management_details: res?.data,
        },
      });
    } else {
      yield put({
        type: actionTypes.GET_USER_MANAGE_DETAILS_FAILED,
        payload: {
          user_management_details: null,
        },
      });
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
}
function* getMerchantUserListData(action) {
  const res = yield call(
    settingServices.getMerchantUserListData,
    action?.payload
  );
  let newMerchantList = [];
  console.log("GET_MERCHANT_USER_LIST", res);
  if (res) {
    if (res?.status) {
      console.log("GET_MERCHANT_USER_LIST", res?.data);
      newMerchantList = res?.data?.user_merchants ?? [];
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("user_merchant_list", newMerchantList));
}
function* updateUserManageData(action) {
  yield put(changeSettingValue("is_update_management_loading", true));
  const res = yield call(settingServices.updateUserManageData, action?.payload);
  console.log("UPDATE_USER_MANAGE_DETAILS", res);
  if (res) {
    if (res?.status) {
      console.log("UPDATE_USER_MANAGE_DETAILS", res?.data);
      yield put(showNotificationWithTimeout(`${res?.message}`, "success"));
      if (res?.data) {
        if (res?.data?.user_management_details) {
          yield put(
            changeSettingValue(
              "user_management_details",
              res?.data?.user_management_details
            )
          );
        }
        if (res?.data?.user_merchants) {
          yield put(
            changeSettingValue("user_merchant_list", res?.data?.user_merchants)
          );
        }
        if (res?.data?.rolelist?.rolelist) {
          yield put(
            changeSettingValue(
              "permission_group_list",
              res?.data?.rolelist?.rolelist
            )
          );
        }
      }
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
      yield put(getMerchantUserList(action?.selectedArr));
      yield put(getPermissionGroupList(action?.selectedArr));
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("is_update_management_loading", false));
}
function* addLinkedEmployeeData(action) {
  yield put(changeSettingValue("is_add_link_emp_modal_loading", true));
  const res = yield call(
    settingServices.addLinkedEmployeeData,
    action?.payload
  );
  console.log("ADD_LINKED_EMP", res);
  if (res) {
    if (res?.status) {
      console.log("ADD_LINKED_EMP", res?.data);
      yield put(showNotificationWithTimeout(`${res?.message}`, "success"));
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("is_add_link_emp_modal_loading", false));
  yield put(changeSettingValue("addLinkEmpModal", false));
}

function* getPermissionGroupListData(action) {
  const res = yield call(
    settingServices.getPermissionGroupListData,
    action?.payload
  );
  let newPermissionGroupList = [];
  console.log("GET_PERMISSION_GROUP_LIST", res);
  if (res) {
    if (res?.status) {
      console.log("GET_PERMISSION_GROUP_LIST", res?.data);
      newPermissionGroupList = res?.data?.rolelist ?? [];
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(
    changeSettingValue("permission_group_list", newPermissionGroupList)
  );
}

/* Cluster Settings */
function* getClusterSetting(action) {
  const res = yield call(settingServices.getClusterSetting, action?.query);
  console.log("GET_CLUSTER_SETTINGS", res);
  if (res) {
    if (res?.status) {
      console.log("GET_CLUSTER_SETTINGS", res?.data);
      yield put({
        type: actionTypes.GET_CLUSTER_SETTINGS_SUCCEEDED,
        payload: {
          cluster_details: res?.data,
        },
      });
    } else {
      yield put({
        type: actionTypes.GET_CLUSTER_SETTINGS_FAILED,
        payload: {
          cluster_details: null,
        },
      });
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
}
function* addClusterDetails(action) {
  let newAddCluster = null;
  const res = yield call(settingServices.addClusterDetails, action?.query);
  console.log("ADD_CLUSTER_DETAILS", res);
  if (res) {
    if (res?.status) {
      console.log("ADD_CLUSTER_DETAILS", res?.data);
      newAddCluster = res?.data;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("add_cluster_details", newAddCluster));
}

function* saveClusterdetails(action) {
  yield put(changeSettingValue("is_save_cluster_loading", true));
  let res;
  if (action?.payload?.cluster_id) {
    res = yield call(settingServices.editClusterdetails, action?.payload);
  } else {
    res = yield call(settingServices.saveClusterdetails, action?.payload);
  }
  console.log("SAVE_CLUSTER_DETAILS", res);
  if (res) {
    if (res?.status) {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? "Success"}`, "success")
      );
      if (res?.data?.selected_cluster_details) {
        yield put(
          changeSettingValue(
            "selected_cluster_details",
            res?.data?.selected_cluster_details
          )
        );
      }
      if (res?.data?.add_cluster_details) {
        yield put(
          changeSettingValue(
            "add_cluster_details",
            res?.data?.add_cluster_details
          )
        );
      }
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("is_save_cluster_loading", false));
}

function* getClusterModules(action) {
  const res = yield call(settingServices.getClusterModules, action?.payload);
  let newClusterModules = [];
  if (res) {
    if (res?.status) {
      newClusterModules = res?.data?.cluster_modules ?? [];
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("cluster_modules", newClusterModules));
}
function* addClusterAccess(action) {
  yield put(changeSettingValue("is_add_cluster_settings_loading", true));

  let res;
  if (checkNull(action?.payload?.id)) {
    res = yield call(settingServices.editClusterAccess, action?.payload);
  } else {
    res = yield call(settingServices.addClusterAccess, action?.payload);
  }
  console.log("ADD_CLUSTER_ACCESS", res);
  if (res) {
    if (res?.status) {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? "Success"}`, "success")
      );
      yield put(changeSettingValue("selected_cluster_details", res?.data));
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("is_add_cluster_settings_loading", false));
  yield put(changeSettingValue("addClusSettingsModal", false));
}

function* addClusterStore(action) {
  yield put(changeSettingValue("is_add_cluster_store_loading", true));
  const res = yield call(settingServices.addClusterStore, action?.payload);
  console.log("ADD_CLUSTER_STORE", res);
  if (res) {
    if (res?.status) {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? "Success"}`, "success")
      );
      yield put(changeSettingValue("selected_cluster_details", res?.data));
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("is_add_cluster_store_loading", false));
  yield put(changeSettingValue("addClusStoreModal", false));
}

/* finance - settings */
// general settings
function* getFinanceGeneralDetails(action) {
  const res = yield call(
    settingServices.getFinanceGeneralDetails,
    action?.query
  );
  console.log("GET_FINANCE_GENERAL_SETTINGS", res);
  if (res) {
    if (res?.status) {
      console.log("GET_FINANCE_GENERAL_SETTINGS", res?.data);
      yield put(changeSettingValue("finance_general_details", res?.data));
    } else {
      yield put(changeSettingValue("finance_general_details", null));
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
}

function* saveFinanceGeneralDetails(action) {
  yield put(changeSettingValue("is_save_general_details_loading", true));
  const res = yield call(
    settingServices.saveFinanceGeneralDetails,
    action?.payload
  );
  console.log("GET_FINANCE_GENERAL_SETTINGS", res);
  if (res) {
    if (res?.status) {
      console.log("GET_FINANCE_GENERAL_SETTINGS", res?.data);
      yield put(changeSettingValue("finance_general_details", res?.data));
    } else {
      yield put(changeSettingValue("finance_general_details", null));
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("is_save_general_details_loading", false));
}
function* savePaymentMethodDetails(action) {
  yield put(changeSettingValue("is_save_payment_method_loading", true));
  let res;
  if (checkNull(action?.payload?.id, false)) {
    res = yield call(
      settingServices.updatePaymentMethodDetails,
      action?.payload
    );
  } else {
    res = yield call(settingServices.savePaymentMethodDetails, action?.payload);
  }

  console.log("SAVE_PAYMENT_METHOD", res);
  if (res) {
    if (res?.status) {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? "Success"}`, "success")
      );
      console.log("SAVE_PAYMENT_METHOD", res?.data);
      yield put(changeSettingValue("finance_sale_details", res?.data ?? null));
      yield put(changeSettingValue("payMethodModal", false));
    } else {
      yield put(changeSettingValue("finance_sale_details", null));
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("is_save_payment_method_loading", false));
}
function* saveServicePeriodDetails(action) {
  yield put(changeSettingValue("is_service_period_loading", true));
  let res;
  if (checkNull(action?.payload?.id, false)) {
    res = yield call(
      settingServices.updateServicePeriodDetails,
      action?.payload
    );
  } else {
    res = yield call(settingServices.saveServicePeriodDetails, action?.payload);
  }
  console.log("SAVE_PAYMENT_METHOD", res);
  if (res) {
    if (res?.status) {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? "Success"}`, "success")
      );
      console.log("SAVE_PAYMENT_METHOD", res?.data);
      yield put(changeSettingValue("finance_sale_details", res?.data ?? null));
      yield put(changeSettingValue("servicePeriodModal", false));
    } else {
      yield put(changeSettingValue("finance_sale_details", null));
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("is_service_period_loading", false));
}

function* deletePaymentMethodDetails(action) {
  const res = yield call(
    settingServices.deletePaymentMethodDetails,
    action?.payload
  );
  console.log("DELETE_PAYMENT_METHOD", res);
  if (res) {
    if (res?.status) {
      console.log("DELETE_PAYMENT_METHOD", res?.data);
      yield put(changeSettingValue("finance_sale_details", res?.data ?? null));
    } else {
      yield put(changeSettingValue("finance_sale_details", null));
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
}

function* udpatePaymentMethodOrder(action) {
  const res = yield call(
    settingServices.udpatePaymentMethodOrder,
    action?.payload
  );
  console.log("UPDATE_PAYMENT_METHOD_ORDER", res);
  if (res) {
    if (res?.status) {
      console.log("UPDATE_PAYMENT_METHOD_ORDER", res?.data);
      yield put(changeSettingValue("finance_sale_details", res?.data ?? null));
    } else {
      yield put(changeSettingValue("finance_sale_details", null));
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
}

function* getFinanceSaleDetails(action) {
  const res = yield call(settingServices.getFinanceSaleDetails, action?.query);
  console.log("GET_FINANCE_SALE_SETTINGS", res);
  if (res) {
    if (res?.status) {
      console.log("GET_FINANCE_SALE_SETTINGS", res?.data);
      yield put(changeSettingValue("finance_sale_details", res?.data ?? null));
    } else {
      yield put(changeSettingValue("finance_sale_details", null));
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
}
function* getGroupAccDetails(action) {
  const res = yield call(settingServices.getGroupAccDetails, action?.query);
  let groupAcc = null;
  console.log("GET_GROUP_ACC_LIST", res);
  if (res) {
    if (res?.status) {
      console.log("GET_GROUP_ACC_LIST", res?.data?.group_account);
      groupAcc = res?.data?.group_account ?? null;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("group_account", groupAcc));
}

function* deleteServicePeriodDetails(action) {
  const res = yield call(
    settingServices.deleteServicePeriodDetails,
    action?.payload
  );
  console.log("DELETE_SERVICE_PERIOD", res);
  if (res) {
    if (res?.status) {
      console.log("DELETE_SERVICE_PERIOD", res?.data);
      yield put(changeSettingValue("finance_sale_details", res?.data ?? null));
    } else {
      yield put(changeSettingValue("finance_sale_details", null));
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
}
function* deleteSaleTypeDetails(action) {
  const res = yield call(
    settingServices.deleteSaleTypeDetails,
    action?.payload
  );
  console.log("DELETE_SALE_TYPE", res);
  if (res) {
    if (res?.status) {
      console.log("DELETE_SALE_TYPE", res?.data);
      yield put(changeSettingValue("finance_sale_details", res?.data ?? null));
    } else {
      yield put(changeSettingValue("finance_sale_details", null));
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
}

function* saveSaleTypeDetails(action) {
  yield put(changeSettingValue("is_sale_type_loading", true));
  let res;
  if (checkNull(action?.payload?.id, false)) {
    res = yield call(settingServices.updateSaleTypeDetails, action?.payload);
  } else {
    res = yield call(settingServices.saveSaleTypeDetails, action?.payload);
  }
  console.log("SAVE_PAYMENT_METHOD", res);
  if (res) {
    if (res?.status) {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? "Success"}`, "success")
      );
      console.log("SAVE_PAYMENT_METHOD", res?.data);
      yield put(changeSettingValue("finance_sale_details", res?.data ?? null));
      yield put(changeSettingValue("saleTypeModal", false));
    } else {
      yield put(changeSettingValue("finance_sale_details", null));
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("is_sale_type_loading", false));
}

function* saveChannelDetails(action) {
  yield put(changeSettingValue("is_channel_loading", true));
  let res;
  if (checkNull(action?.payload?.id, false)) {
    res = yield call(settingServices.updateChannelDetails, action?.payload);
  } else {
    res = yield call(settingServices.saveChannelDetails, action?.payload);
  }
  if (res) {
    if (res?.status) {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? "Success"}`, "success")
      );
      yield put(changeSettingValue("finance_sale_details", res?.data ?? null));
      yield put(changeSettingValue("channelModal", false));
    } else {
      yield put(changeSettingValue("finance_sale_details", null));
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("is_channel_loading", false));
}

function* deleteChannelDetails(action) {
  const res = yield call(settingServices.deleteChannelDetails, action?.payload);
  console.log("DELETE_CHANNEL", res);
  if (res) {
    if (res?.status) {
      console.log("DELETE_CHANNEL", res?.data);
      yield put(changeSettingValue("finance_sale_details", res?.data ?? null));
    } else {
      yield put(changeSettingValue("finance_sale_details", null));
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
}

function* saveSaleGroupDetails(action) {
  yield put(changeSettingValue("is_sale_group_loading", true));
  const res = yield call(settingServices.saveSaleGroupDetails, action?.payload);
  if (res) {
    if (res?.status) {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? "Success"}`, "success")
      );
      yield put(changeSettingValue("finance_sale_details", res?.data ?? null));
      yield put(changeSettingValue("saleGroupModal", false));
    } else {
      yield put(changeSettingValue("finance_sale_details", null));
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("is_sale_group_loading", false));
}

function* deleteSaleGroupDetails(action) {
  const res = yield call(
    settingServices.deleteSaleGroupDetails,
    action?.payload
  );
  console.log("DELETE_SALE_GROUP", res);
  if (res) {
    if (res?.status) {
      console.log("DELETE_SALE_GROUP", res?.data);
      yield put(changeSettingValue("finance_sale_details", res?.data ?? null));
    } else {
      yield put(changeSettingValue("finance_sale_details", null));
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
}

function* getPublicHolidayDetails(action) {
  const res = yield call(
    settingServices.getPublicHolidayDetails,
    action?.query
  );
  console.log("GET_PUBLIC_HOLIDAY", res);
  if (res) {
    if (res?.status) {
      console.log("GET_PUBLIC_HOLIDAY", res?.data);
      yield put(
        changeSettingValue("public_holiday_details", res?.data ?? null)
      );
    } else {
      yield put(changeSettingValue("public_holiday_details", null));
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
}

function* savePublicHolidayDetails(action) {
  yield put(changeSettingValue("is_public_holiday_loading", true));
  const res = yield call(
    settingServices.savePublicHolidayDetails,
    action?.payload
  );
  if (res) {
    if (res?.status) {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? "Success"}`, "success")
      );
      yield put(
        changeSettingValue("public_holiday_details", res?.data ?? null)
      );
      yield put(changeSettingValue("publicHolidayModal", false));
    } else {
      yield put(changeSettingValue("public_holiday_details", null));
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("is_public_holiday_loading", false));
}

function* deletePublicHolidayDetails(action) {
  const res = yield call(
    settingServices.deletePublicHolidayDetails,
    action?.payload
  );
  if (res) {
    if (res?.status) {
      yield put(
        changeSettingValue("public_holiday_details", res?.data ?? null)
      );
    } else {
      yield put(changeSettingValue("public_holiday_details", null));
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
}

function* getMasterSettingDetails(action) {
  const res = yield call(
    settingServices.getMasterSettingDetails,
    action?.query
  );
  console.log("GET_MASTER_SETTING", res);
  if (res) {
    if (res?.status) {
      console.log("GET_MASTER_SETTING", res?.data);
      yield put(
        changeSettingValue("master_setting_details", res?.data ?? null)
      );
    } else {
      yield put(changeSettingValue("master_setting_details", null));
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
}
function* savePmMasterSettingDetails(action) {
  yield put(changeSettingValue("is_pmMasterSetting_loading", true));
  const master_setting_details = yield select(
    (state) => state?.settingReducer?.master_setting_details
  );
  const res = yield call(
    settingServices.savePmMasterSettingDetails,
    action?.payload
  );
  if (res) {
    if (res?.status) {
      console.log("SAVE_PM_MASTER_SETTING", res?.data);
      yield put(
        showNotificationWithTimeout(`${res?.message ?? "Success"}`, "success")
      );
      yield put(changeSettingValue("pmMasterSettingModal", false));
      yield put(
        changeSettingValue("master_setting_details", {
          ...master_setting_details,
          payment_methods: res?.data?.payment_methods ?? null,
        })
      );
    } else {
      yield put(changeSettingValue("master_setting_details", null));
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("is_pmMasterSetting_loading", false));
}
function* updatePmMasterSettingDetails(action) {
  yield put(changeSettingValue("is_editPmMasterSetting_loading", false));
  const master_setting_details = yield select(
    (state) => state?.settingReducer?.master_setting_details
  );
  const res = yield call(
    settingServices.updatePmMasterSettingDetails,
    action?.payload
  );
  if (res) {
    if (res?.status) {
      console.log("UPDATE_PM_MASTER_SETTING", res?.data);
      yield put(
        showNotificationWithTimeout(`${res?.message ?? "Success"}`, "success")
      );
      yield put(
        changeSettingValue("master_setting_details", {
          ...master_setting_details,
          payment_methods: res?.data?.payment_methods ?? null,
        })
      );
      yield put(changeSettingValue("editPmMasterSettingModal", false));
    } else {
      yield put(changeSettingValue("master_setting_details", null));
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("is_editPmMasterSetting_loading", true));
}
function* updatePmMasterSettingStatusDetails(action) {
  const master_setting_details = yield select(
    (state) => state?.settingReducer?.master_setting_details
  );
  const res = yield call(
    settingServices.updatePmMasterSettingStatusDetails,
    action?.payload
  );
  if (res) {
    if (res?.status) {
      console.log("UPDATE_PM_MASTER_SETTING_STATUS", res?.data);
      yield put(
        showNotificationWithTimeout(`${res?.message ?? "Success"}`, "success")
      );
      yield put(
        changeSettingValue("master_setting_details", {
          ...master_setting_details,
          payment_methods: res?.data?.payment_methods ?? null,
        })
      );
    } else {
      yield put(changeSettingValue("master_setting_details", null));
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
}
function* refreshPmMasterSettingDetails(action) {
  const master_setting_details = yield select(
    (state) => state?.settingReducer?.master_setting_details
  );
  const res = yield call(
    settingServices.refreshPmMasterSettingDetails,
    action?.payload
  );
  if (res) {
    if (res?.status) {
      console.log("REFRESH_PM_MASTER_SETTING", res?.data);
      yield put(
        showNotificationWithTimeout(`${res?.message ?? "Success"}`, "success")
      );
      yield put(
        changeSettingValue("master_setting_details", {
          ...master_setting_details,
          payment_methods: res?.data?.payment_methods ?? null,
        })
      );
    } else {
      yield put(changeSettingValue("master_setting_details", null));
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
}

function* saveSalesMasterSettingDetails(action) {
  yield put(changeSettingValue("is_salesMasterSetting_loading", true));
  const master_setting_details = yield select(
    (state) => state?.settingReducer?.master_setting_details
  );
  const res = yield call(
    settingServices.saveSalesMasterSettingDetails,
    action?.payload
  );
  if (res) {
    if (res?.status) {
      console.log("SAVE_SALES_MASTER_SETTING", res?.data);
      yield put(
        showNotificationWithTimeout(`${res?.message ?? "Success"}`, "success")
      );
      yield put(changeSettingValue("salesMasterSettingModal", false));
      yield put(
        changeSettingValue("master_setting_details", {
          ...master_setting_details,
          sales_types: res?.data?.sales_types ?? null,
        })
      );
    } else {
      yield put(changeSettingValue("master_setting_details", null));
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("is_salesMasterSetting_loading", false));
}
function* updateSalesMasterSettingDetails(action) {
  yield put(changeSettingValue("is_editSalesMasterSetting_loading", false));
  const master_setting_details = yield select(
    (state) => state?.settingReducer?.master_setting_details
  );
  const res = yield call(
    settingServices.updateSalesMasterSettingDetails,
    action?.payload
  );
  if (res) {
    if (res?.status) {
      console.log("UPDATE_SALES_MASTER_SETTING", res?.data);
      yield put(
        showNotificationWithTimeout(`${res?.message ?? "Success"}`, "success")
      );
      yield put(
        changeSettingValue("master_setting_details", {
          ...master_setting_details,
          sales_types: res?.data?.sales_types ?? null,
        })
      );
      yield put(changeSettingValue("editSalesMasterSettingModal", false));
    } else {
      yield put(changeSettingValue("master_setting_details", null));
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("is_editSalesMasterSetting_loading", true));
}
function* updateSalesMasterSettingStatusDetails(action) {
  const master_setting_details = yield select(
    (state) => state?.settingReducer?.master_setting_details
  );
  const res = yield call(
    settingServices.updateSalesMasterSettingStatusDetails,
    action?.payload
  );
  if (res) {
    if (res?.status) {
      console.log("UPDATE_SALES_MASTER_SETTING_STATUS", res?.data);
      yield put(
        showNotificationWithTimeout(`${res?.message ?? "Success"}`, "success")
      );
      yield put(
        changeSettingValue("master_setting_details", {
          ...master_setting_details,
          sales_types: res?.data?.sales_types ?? null,
        })
      );
    } else {
      yield put(changeSettingValue("master_setting_details", null));
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
}
function* refreshSalesMasterSettingDetails(action) {
  const master_setting_details = yield select(
    (state) => state?.settingReducer?.master_setting_details
  );
  const res = yield call(
    settingServices.refreshSalesMasterSettingDetails,
    action?.payload
  );
  if (res) {
    if (res?.status) {
      console.log("REFRESH_SALES_MASTER_SETTING", res?.data);
      yield put(
        showNotificationWithTimeout(`${res?.message ?? "Success"}`, "success")
      );
      yield put(
        changeSettingValue("master_setting_details", {
          ...master_setting_details,
          sales_types: res?.data?.sales_types ?? null,
        })
      );
    } else {
      yield put(changeSettingValue("master_setting_details", null));
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
}

function* saveServicePeriodsMasterSettingDetails(action) {
  yield put(changeSettingValue("is_servicePeriodsMasterSetting_loading", true));
  const master_setting_details = yield select(
    (state) => state?.settingReducer?.master_setting_details
  );
  const res = yield call(
    settingServices.saveServicePeriodsMasterSettingDetails,
    action?.payload
  );
  if (res) {
    if (res?.status) {
      console.log("SAVE_SALES_MASTER_SETTING", res?.data);
      yield put(
        showNotificationWithTimeout(`${res?.message ?? "Success"}`, "success")
      );
      yield put(changeSettingValue("servicePeriodsMasterSettingModal", false));
      yield put(
        changeSettingValue("master_setting_details", {
          ...master_setting_details,
          service_periods: res?.data?.service_periods ?? null,
        })
      );
    } else {
      yield put(changeSettingValue("master_setting_details", null));
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(
    changeSettingValue("is_servicePeriodsMasterSetting_loading", false)
  );
}
function* updateServicePeriodsMasterSettingDetails(action) {
  yield put(
    changeSettingValue("is_editServicePeriodsMasterSetting_loading", false)
  );
  const master_setting_details = yield select(
    (state) => state?.settingReducer?.master_setting_details
  );
  const res = yield call(
    settingServices.updateServicePeriodsMasterSettingDetails,
    action?.payload
  );
  if (res) {
    if (res?.status) {
      console.log("UPDATE_SALES_MASTER_SETTING", res?.data);
      yield put(
        showNotificationWithTimeout(`${res?.message ?? "Success"}`, "success")
      );
      yield put(
        changeSettingValue("master_setting_details", {
          ...master_setting_details,
          service_periods: res?.data?.service_periods ?? null,
        })
      );
      yield put(
        changeSettingValue("editServicePeriodsMasterSettingModal", false)
      );
    } else {
      yield put(changeSettingValue("master_setting_details", null));
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(
    changeSettingValue("is_editServicePeriodsMasterSetting_loading", true)
  );
}
function* updateServicePeriodsMasterSettingStatusDetails(action) {
  const master_setting_details = yield select(
    (state) => state?.settingReducer?.master_setting_details
  );
  const res = yield call(
    settingServices.updateServicePeriodsMasterSettingStatusDetails,
    action?.payload
  );
  if (res) {
    if (res?.status) {
      console.log("UPDATE_SALES_MASTER_SETTING_STATUS", res?.data);
      yield put(
        showNotificationWithTimeout(`${res?.message ?? "Success"}`, "success")
      );
      yield put(
        changeSettingValue("master_setting_details", {
          ...master_setting_details,
          service_periods: res?.data?.service_periods ?? null,
        })
      );
    } else {
      yield put(changeSettingValue("master_setting_details", null));
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
}
function* refreshServicePeriodsMasterSettingDetails(action) {
  const master_setting_details = yield select(
    (state) => state?.settingReducer?.master_setting_details
  );
  const res = yield call(
    settingServices.refreshServicePeriodsMasterSettingDetails,
    action?.payload
  );
  if (res) {
    if (res?.status) {
      console.log("REFRESH_SALES_MASTER_SETTING", res?.data);
      yield put(
        showNotificationWithTimeout(`${res?.message ?? "Success"}`, "success")
      );
      yield put(
        changeSettingValue("master_setting_details", {
          ...master_setting_details,
          service_periods: res?.data?.service_periods ?? null,
        })
      );
    } else {
      yield put(changeSettingValue("master_setting_details", null));
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
}

function* saveChannelsMasterSettingDetails(action) {
  yield put(changeSettingValue("is_channelsMasterSetting_loading", true));
  const master_setting_details = yield select(
    (state) => state?.settingReducer?.master_setting_details
  );
  const res = yield call(
    settingServices.saveChannelsMasterSettingDetails,
    action?.payload
  );
  if (res) {
    if (res?.status) {
      console.log("SAVE_CHANNELS_MASTER_SETTING", res?.data);
      yield put(
        showNotificationWithTimeout(`${res?.message ?? "Success"}`, "success")
      );
      yield put(changeSettingValue("channelsMasterSettingModal", false));
      yield put(
        changeSettingValue("master_setting_details", {
          ...master_setting_details,
          channels: res?.data?.channels ?? null,
        })
      );
    } else {
      yield put(changeSettingValue("master_setting_details", null));
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("is_channelsMasterSetting_loading", false));
}
function* updateChannelsMasterSettingDetails(action) {
  yield put(changeSettingValue("is_editChannelsMasterSetting_loading", false));
  const master_setting_details = yield select(
    (state) => state?.settingReducer?.master_setting_details
  );
  const res = yield call(
    settingServices.updateChannelsMasterSettingDetails,
    action?.payload
  );
  if (res) {
    if (res?.status) {
      console.log("UPDATE_CHANNELS_MASTER_SETTING", res?.data);
      yield put(
        showNotificationWithTimeout(`${res?.message ?? "Success"}`, "success")
      );
      yield put(
        changeSettingValue("master_setting_details", {
          ...master_setting_details,
          channels: res?.data?.channels ?? null,
        })
      );
      yield put(changeSettingValue("editChannelsMasterSettingModal", false));
    } else {
      yield put(changeSettingValue("master_setting_details", null));
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("is_editChannelsMasterSetting_loading", true));
}
function* updateChannelsMasterSettingStatusDetails(action) {
  const master_setting_details = yield select(
    (state) => state?.settingReducer?.master_setting_details
  );
  const res = yield call(
    settingServices.updateChannelsMasterSettingStatusDetails,
    action?.payload
  );
  if (res) {
    if (res?.status) {
      console.log("UPDATE_CHANNELS_MASTER_SETTING_STATUS", res?.data);
      yield put(
        showNotificationWithTimeout(`${res?.message ?? "Success"}`, "success")
      );
      yield put(
        changeSettingValue("master_setting_details", {
          ...master_setting_details,
          channels: res?.data?.channels ?? null,
        })
      );
    } else {
      yield put(changeSettingValue("master_setting_details", null));
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
}
function* refreshChannelsMasterSettingDetails(action) {
  const master_setting_details = yield select(
    (state) => state?.settingReducer?.master_setting_details
  );
  const res = yield call(
    settingServices.refreshChannelsMasterSettingDetails,
    action?.payload
  );
  if (res) {
    if (res?.status) {
      console.log("REFRESH_CHANNELS_MASTER_SETTING", res?.data);
      yield put(
        showNotificationWithTimeout(`${res?.message ?? "Success"}`, "success")
      );
      yield put(
        changeSettingValue("master_setting_details", {
          ...master_setting_details,
          channels: res?.data?.channels ?? null,
        })
      );
    } else {
      yield put(changeSettingValue("master_setting_details", null));
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
}

function* updateMatrixSetting(action) {
  const res = yield call(settingServices.updateMatrixSetting, action?.payload);
  if (res) {
    if (res?.status) {
      yield put(changeSettingValue("finance_sale_details", res?.data ?? null));
    } else {
      yield put(changeSettingValue("finance_sale_details", null));
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
}

function* getFinanceChartOfAccSettingDetails(action) {
  const res = yield call(
    settingServices.getFinanceChartOfAccSettingDetails,
    action?.query
  );
  console.log("GET_FINANCE_CHARTS_OF_ACC_SETTINGS", res);
  if (res) {
    if (res?.status) {
      console.log("GET_FINANCE_CHARTS_OF_ACC_SETTINGS", res?.data);
      yield put(
        changeSettingValue("chart_of_accounts_details", res?.data ?? null)
      );
    } else {
      yield put(changeSettingValue("chart_of_accounts_details", null));
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
}
function* getFinanceAccDetails(action) {
  const sub_accounts_details = yield select(
    (state) => state?.settingReducer?.sub_accounts_details
  );
  const group_id = action?.queryData?.group_id;
  const parent_account_id = action?.queryData?.parent_account_id;
  const type = action?.queryData?.type;
  const page = action?.queryData?.page;
  const pagesize = action?.queryData?.pagesize;
  const query = `?group_id=${group_id}&type=${type}&parent_account_id=${parent_account_id}&page=${page}&pagesize=${pagesize}`;
  const res = yield call(settingServices.getFinanceAccDetails, query);
  console.log("GET_FINANCE_ACCOUNTS", res);
  if (res) {
    if (res?.status) {
      console.log("GET_FINANCE_ACCOUNTS", res?.data);
      if (checkArray(res?.data?.finance_accounts?.data)) {
        let subAccData = {
          group_id,
          parent_account_id,
          type,
          page,
          pagesize,
          totalPages: res?.data?.totalPages,
          data: res?.data?.finance_accounts?.data,
        };
        if (checkNull(sub_accounts_details?.[parent_account_id], false)) {
          const mergeArr = [
            ...(sub_accounts_details?.[parent_account_id]?.data ?? []),
            ...res?.data?.finance_accounts?.data,
          ];
          subAccData = {
            ...sub_accounts_details?.[parent_account_id],
            data: mergeArr,
          };
        }
        const newSubAccounts = {
          ...sub_accounts_details,
          [parent_account_id]: subAccData,
        };
        yield put(changeSettingValue("sub_accounts_details", newSubAccounts));
      }
    } else {
      if (checkNull(sub_accounts_details?.[parent_account_id], false)) {
        const newSubAccounts = {
          ...sub_accounts_details,
        };
        delete newSubAccounts[parent_account_id];
        yield put(changeSettingValue("sub_accounts_details", newSubAccounts));
      }
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
}

function* downloadAllFinanceAccDetail(action) {
  const res = yield call(
    settingServices.downloadAllFinanceAccDetail,
    action.query
  );

  if (res?.status && res?.data?.export_excel) {
    yield call(downloadFileFromUrl, res?.data?.export_excel);
  } else {
    yield put(
      showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
    );
  }
}

function* addFinanceAccDetail(action) {
  let accDetail = null;
  const res = yield call(settingServices.addFinanceAccDetail, action?.query);
  console.log("ADD_FINANCE_ACCOUNTS", res);
  if (res) {
    if (res?.status) {
      console.log("ADD_FINANCE_ACCOUNTS", res?.data);
      accDetail = res?.data ?? null;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("add_accounts_details", accDetail));
}
function* addFinanceSubAccDetail(action) {
  let accDetail = null;
  const res = yield call(settingServices.addFinanceSubAccDetail, action?.query);
  console.log("ADD_FINANCE_SUB_ACCOUNTS", res);
  if (res) {
    if (res?.status) {
      console.log("ADD_FINANCE_SUB_ACCOUNTS", res?.data);
      accDetail = res?.data ?? null;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("add_accounts_details", accDetail));
}
function* getUpdateFinanceSubAccDetail(action) {
  let accDetail = null;
  const res = yield call(
    settingServices.getUpdateFinanceSubAccDetail,
    action?.query
  );
  console.log("GET_UPDATE_FINANCE_SUB_ACCOUNTS", res);
  if (res) {
    if (res?.status) {
      console.log("GET_UPDATE_FINANCE_SUB_ACCOUNTS", res?.data);
      accDetail = res?.data ?? null;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("add_accounts_details", accDetail));
}

function* getSubAccTransactionsDetails(action) {
  let accDetail = null;
  const res = yield call(
    settingServices.getSubAccTransactionsDetails,
    action?.query,
    action?.payload
  );
  console.log("GET_SUB_ACCOUNT_TRANSACTIONS", res);
  if (res) {
    if (res?.status) {
      console.log("GET_SUB_ACCOUNT_TRANSACTIONS", res?.data?.transactions);
      accDetail = res?.data?.transactions ?? null;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("sub_acc_transactions_details", accDetail));
}

function* saveFinanceSubAccDetail(action) {
  let accDetail = null;
  const res = yield call(
    settingServices.saveFinanceSubAccDetail,
    action?.query,
    action?.payload
  );
  console.log("SAVE_FINANCE_SUB_ACCOUNTS", res);
  if (res) {
    if (res?.status) {
      console.log("SAVE_FINANCE_SUB_ACCOUNTS", res?.data);
      yield put(
        showNotificationWithTimeout(`${res?.message ?? "Success"}`, "success")
      );
      yield put(changeSettingValue("is_redirect_accounts_id", true));
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  // yield put(changeSettingValue("save_accounts_details", accDetail));
}

function* saveEditSubAccDetail(action) {
  const res = yield call(
    settingServices.saveEditSubAccDetail,
    action?.query,
    action?.payload
  );
  console.log("SAVE_EDIT_SUB_ACCOUNT", res);
  if (res) {
    if (res?.status) {
      console.log("SAVE_EDIT_SUB_ACCOUNT", res?.data);
      yield put(
        showNotificationWithTimeout(`${res?.message ?? "Success"}`, "success")
      );
      if (action?.isSave)
        yield put(changeSettingValue("is_redirect_accounts_id", true));
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
}

function* getAddTransSubAccDetail(action) {
  let accDetail = null;
  const res = yield call(
    settingServices.getAddTransSubAccDetail,
    action?.query
  );
  console.log("GET_ADD_TRANS_SUB_ACCOUNTS", res);
  if (res) {
    if (res?.status) {
      console.log("GET_ADD_TRANS_SUB_ACCOUNTS", res?.data);
      accDetail = res?.data ?? null;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("add_accounts_details", accDetail));
}

function* getDebitCreditAccDetails(action) {
  const add_accounts_details = yield select(
    (state) => state?.settingReducer?.add_accounts_details
  );
  let debitCreditDetail = null;
  const res = yield call(
    settingServices.getDebitCreditAccDetails,
    action?.payload
  );
  console.log("GET_DEBIT_CREDIT_ACCOUNT", res);
  console.log("action?.accType", action?.accType);
  if (res) {
    if (res?.status) {
      console.log("GET_DEBIT_CREDIT_ACCOUNT", res?.data);
      debitCreditDetail = res?.data?.return ?? null;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  if (action?.accType != "") {
    yield put(changeSettingValue("newDebitCreditDetail", debitCreditDetail));
  } else {
    yield put(
      changeSettingValue("add_accounts_details", {
        ...add_accounts_details,
        debitCreditDetail,
      })
    );
  }
}

function* saveAccTransaction(action) {
  const res = yield call(
    settingServices.saveAccTransaction,
    action?.query,
    action?.payload
  );
  console.log("SAVE_ACCOUNT_TRANSACTION", res);
  if (res) {
    if (res?.status) {
      console.log("SAVE_ACCOUNT_TRANSACTION", res?.data);
      yield put(
        showNotificationWithTimeout(`${res?.message ?? "Success"}`, "success")
      );
      yield put(changeSettingValue("is_redirect_accounts_id", true));
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
}

// Forecast
function* getForecastSettingsDetail(action) {
  let forecastDetail = null;
  const res = yield call(
    settingServices.getForecastSettingsDetail,
    action?.query
  );
  console.log("GET_FINANCE_FORECAST_SETTINGS", res);
  if (res) {
    if (res?.status) {
      console.log("GET_FINANCE_FORECAST_SETTINGS", res?.data);
      forecastDetail = res?.data ?? null;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("forecast_detail", forecastDetail));
}
function* getForecastRulesDetail(action) {
  let forecastDetail =
    action?.ruleType == 1
      ? yield select((state) => state?.settingReducer?.forecast_detail)
      : yield select((state) => state?.settingReducer?.editRevenueRuleDetail);
  const res = yield call(settingServices.getForecastRulesDetail, action?.query);
  console.log("GET_FORECAST_RULE", res);
  if (res) {
    if (res?.status) {
      console.log("GET_FORECAST_RULE", res?.data?.rules);
      forecastDetail.forecast_rule2 = res?.data?.rules ?? [];
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  if (action?.ruleType == 1) {
    yield put(changeSettingValue("forecast_detail", forecastDetail));
  } else {
    yield put(changeSettingValue("editRevenueRuleDetail", forecastDetail));
  }
}

function* getApplicableQuarterDetail(action) {
  let forecastDetail = yield select(
    (state) => state?.settingReducer?.forecast_detail
  );
  const res = yield call(
    settingServices.getApplicableQuarterDetail,
    action?.payload
  );
  console.log("GET_APPLICABLE_QUARTER", res);
  if (res) {
    if (res?.status) {
      console.log("GET_APPLICABLE_QUARTER", res?.data?.quarters);
      forecastDetail.quarter = res?.data?.quarters ?? null;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("forecast_detail", forecastDetail));
}
function* saveForecastSettingsDetail(action) {
  let forecastDetail = yield select(
    (state) => state?.settingReducer?.forecast_detail
  );
  const res = yield call(
    settingServices.saveForecastSettingsDetail,
    action?.payload
  );
  console.log("SAVE_FINANCE_FORECAST_SETTINGS", res);
  if (res) {
    if (res?.status) {
      console.log("SAVE_FINANCE_FORECAST_SETTINGS", res?.data);

      yield put(changeSettingValue("addRevenueRuleModal", false));
      yield put(changeSettingValue("addCostModal", false));
      const newForcastValue = checkArray(res?.data?.forecast_value)
        ? res?.data?.forecast_value
        : [];

      yield put(
        changeSettingValue("forecast_detail", {
          ...forecastDetail,
          forecast_value: newForcastValue,
        })
      );
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
}
function* editFinanceRuleDetail(action) {
  let editDetail = null;
  yield put(changeSettingValue("editRevenueRuleId", action?.query));
  const res = yield call(
    settingServices.editFinanceRuleDetail,
    `/${action?.query}`
  );
  console.log("EDIT_FINANCE_RULE", res);
  if (res) {
    if (res?.status) {
      console.log("EDIT_FINANCE_RULE", res?.data);
      if (res?.data) {
        editDetail = res?.data ?? null;
        yield put(changeSettingValue("editRevenueRuleModal", true));
      }
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("editRevenueRuleDetail", editDetail));
  yield put(changeSettingValue("editRevenueRuleId", ""));
}
function* updateFinanceRuleDetail(action) {
  let forecastDetail = yield select(
    (state) => state?.settingReducer?.forecast_detail
  );
  let editDetail = null;
  const res = yield call(
    settingServices.updateFinanceRuleDetail,
    `/${action?.query}`,
    action?.payload
  );
  console.log("UPDATE_FINANCE_RULE", res);
  if (res) {
    if (res?.status) {
      console.log("UPDATE_FINANCE_RULE", res?.data);
      if (res?.data) {
        editDetail = null;
        yield put(changeSettingValue("editRevenueRuleModal", false));
        yield put(changeSettingValue("editRevenueRuleDetail", null));
        const newForcastValue = checkArray(res?.data?.forecast_value)
          ? res?.data?.forecast_value
          : [];

        yield put(
          changeSettingValue("forecast_detail", {
            ...forecastDetail,
            forecast_value: newForcastValue,
          })
        );
      }
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("editRevenueRuleDetail", editDetail));
}

function* getOnlifeData(action) {
  const res = yield call(settingServices.getOnlifeData);
  console.log();
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.saveOnlifeData(data));
  }
}

function* postMerchantOnlifeData(action) {
  console.log(action.payload, "inSaga");
  const res = yield call(
    settingServices.postMerchantOnlifeData,
    action?.payload
  );
  if (res.status && res.data) {
    yield put(
      showNotificationWithTimeout(`${res?.message ?? errMsg}`, "success")
    );
  } else {
    yield put(
      showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
    );
  }
}

function* postCompetitorOnlifeData(action) {
  console.log(action.payload, "inSaga");
  const res = yield call(
    settingServices.postCompetitorOnlifeData,
    action?.payload
  );
  if (res.status && res.data) {
    yield put(actions.getOnlifeData());
    yield put(
      showNotificationWithTimeout(`${res?.message ?? errMsg}`, "success")
    );
  } else {
    yield put(
      showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
    );
  }
}

function* deleteCompetitorOnlifeData(action) {
  console.log(action.payload, "inSaga");
  const res = yield call(
    settingServices.deleteCompetitorOnlifeData,
    action?.payload
  );
  if (res.status && res.data) {
    yield put(actions.getOnlifeData());
    yield put(
      showNotificationWithTimeout(`${res?.message ?? errMsg}`, "success")
    );
  } else {
    yield put(
      showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
    );
  }
}

// Reconcile

function* getReconsileDetail(action) {
  let reconcileDetail = null;
  const res = yield call(settingServices.getReconsileDetail, action?.query);
  console.log("GET_RECONSILE_SETTINGS", res);
  if (res) {
    if (res?.status) {
      console.log("GET_RECONSILE_SETTINGS", res?.data);
      reconcileDetail = res?.data ?? null;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("reconcile_detail", reconcileDetail));
}

function* saveReconsileDetail(action) {
  yield put(changeSettingValue("is_addReconcileModal_loading", true));
  const res = yield call(settingServices.saveReconsileDetail, action?.payload);
  console.log("ADD_RECONSILE_SETTINGS", res);
  if (res) {
    if (res?.status) {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? "Success"}`, "success")
      );
      console.log("ADD_RECONSILE_SETTINGS", res?.data);
      yield put(changeSettingValue("addReconcileModal", false));
      yield put(
        changeSettingValue("redirect_reconcile_id", res?.data?.id ?? "")
      );
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("is_addReconcileModal_loading", false));
}
function* deleteReconsileDetail(action) {
  yield put(changeSettingValue("delete_reconcile_id", action?.payload?.id));
  let reconcileDetail = null;
  const res = yield call(
    settingServices.deleteReconsileDetail,
    action?.payload
  );
  console.log("DELETE_RECONSILE_SETTINGS", res);
  if (res) {
    if (res?.status) {
      console.log("DELETE_RECONSILE_SETTINGS", res?.data);
      reconcileDetail = res?.data ?? null;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("reconcile_detail", reconcileDetail));
  yield put(changeSettingValue("delete_reconcile_id", ""));
}

function* getReconsileUploadDetail(action) {
  let reconcileDetail = null;
  const res = yield call(
    settingServices.getReconsileUploadDetail,
    action?.query
  );
  console.log("GET_RECONSILE_UPLOAD_SETTINGS", res);
  if (res) {
    if (res?.status) {
      console.log("GET_RECONSILE_UPLOAD_SETTINGS", res?.data);
      reconcileDetail = res?.data ?? null;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("reconcile_detail", reconcileDetail));
}
function* saveReconsileUploadDetail(action) {
  let reconcileDetail = false;
  const res = yield call(
    settingServices.saveReconsileUploadDetail,
    action?.query,
    action?.payload
  );
  console.log("SAVE_RECONSILE_UPLOAD_SETTINGS", res);
  if (res) {
    if (res?.status) {
      console.log("SAVE_RECONSILE_UPLOAD_SETTINGS", res?.data);
      reconcileDetail = true;
    } else {
      yield put(
        showNotificationWithTimeout(`${res?.message ?? errMsg}`, "error")
      );
    }
  } else {
    yield put(showNotificationWithTimeout(`${errMsg}`, "error"));
  }
  yield put(changeSettingValue("redirect_reconcile_page", reconcileDetail));
}

// POS MASTER --> POS MASTER
function* getPosMasterData(action) {
  const res = yield call(settingServices.getPosMasterData, action.payload);
  if (res?.status && res?.data) {
    const data = res.data;
    yield put(actions.savePosMasterData(data));
  }
}

function* postPosMasterActiveStatus(action) {
  console.log("hiiiiiiii");
  const res = yield call(
    settingServices?.postPosMasterActiveStatus,
    action.payload
  );
  if (res?.status && res?.data) {
    yield put(actions.getPosMasterData());
  }
}
function* getPosMasterFormOptions(action) {
  console.log("aaaaaaaaaaa");

  const res = yield call(
    settingServices.getPosMasterFormOptions,
    action.payload
  );
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.savePosMasterFormOptions(data));
  }
}

function* getEditPosMasterFormData(action) {
  console.log(action, "aaahhh");
  const res = yield call(
    settingServices.getEditPosMasterFormData,
    action?.query
  );
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.saveEditPosMasterFormData(data));
  }
}

function* postPosIntegrationSetting(action) {
  const res = yield call(
    settingServices.postPosIntegrationSetting,
    action.payload
  );
  if (res?.status && res?.data) {
    const data = res?.data?.settings;
    yield put(actions.savePosIntegrationSettingData(data));
    yield put(
      actions.setModalState({
        modalName: "pos_integration_modal_state",
        modalState: false,
      })
    );
  }
}
function* getApplicableModule(action) {
  const res = yield call(settingServices.getApplicableModule, action?.query);
  const data = res?.data?.config;
  if (data) yield put(actions.saveApplicableModule(data));
}

function* getFrequency(action) {
  const res = yield call(settingServices.getFrequency, action?.query);
  const data = res?.data?.config;
  if (data) yield put(actions.saveFrequency(data));
}
function* postAddPosMasterFormData(action) {
  console.log("i am in add saga", action.payload);
  const res = yield call(
    settingServices.postAddPosMasterFormData,
    action.payload
  );
  if (res?.status && res?.data) {
    const data = res.data;
    yield put(actions.savePosMasterData(data));
    yield put(
      actions.setFormState({
        formName: "pos_form_state",
        formState: false,
      })
    );
  }
}

function* postEditPosMasterFormData(action) {
  const res = yield call(
    settingServices.postEditPosMasterFormData,
    action.payload
  );
  if (res?.status && res?.data) {
    const data = res.data;
    yield put(actions.savePosMasterData(data));
  }
}

// POS MASTER --> LAYOUT MASTER
function* getRoomsLayoutData(action) {
  const res = yield call(settingServices.getRoomsLayoutData, action.payload);
  if (res?.status && res?.data) {
    const data = res?.data?.rooms;
    yield put(actions.saveRoomsLayoutData(data));
  }
}

function* postAddRoomLayout(action) {
  const res = yield call(settingServices.postAddRoomLayout, action.payload);
  console.log(res, "res");
  if (res?.status && res?.data) {
    const data = res?.data?.rooms;
    yield put(actions.saveRoomsLayoutData(data));
    yield put(
      actions.setFormState({
        formName: "rooms_layout_form_state",
        formState: false,
      })
    );
  }
}
function* getEditRoomLayout(action) {
  const res = yield call(settingServices.getEditRoomLayout, action.query);
  console.log(res, "res");
  if (res?.status && res?.data) {
    const data = res?.data?.pos_room;
    yield put(actions.saveEditRoomLayout(data));
  }
}
function* postEditRoomLayout(action) {
  const res = yield call(settingServices.postEditRoomLayout, action.payload);
  console.log(res, "res");
  if (res?.status && res?.data) {
    const data = res?.data?.rooms;
    yield put(actions.saveRoomsLayoutData(data));
    yield put(
      actions.setFormState({
        formName: "rooms_layout_form_state",
        formState: false,
      })
    );
  }
}

function* deleteRoomLayout(action) {
  const res = yield call(settingServices.deleteRoomLayout, action.query);
  console.log(res, "res");
  if (res?.status && res?.data) {
    const data = res?.data?.rooms;
    yield put(actions.saveRoomsLayoutData(data));
  }
}

//table master
function* getTableMasterData(action) {
  const res = yield call(settingServices.getTableMasterData, action.payload);
  console.log(res, "res");
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.saveTableMasterData(data));
  }
}

function* getTableMasterFormData(action) {
  const res = yield call(
    settingServices.getTableMasterFormData,
    action.payload
  );
  console.log(res, "res");
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.saveTableMasterFormData(data));
  }
}
function* postAddTableMasterFormData(action) {
  console.log("yessssssssss");
  const res = yield call(
    settingServices.postAddTableMasterFormData,
    action.payload
  );
  console.log(res, "res");
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.saveTableMasterData(data));
    yield put(
      actions.setFormState({
        formName: "table_master_form_state",
        formState: false,
      })
    );
  }
}
function* getEditTableMasterFormData(action) {
  console.log("yessssssssss", action);
  const res = yield call(
    settingServices.getEditTableMasterFormData,
    action.payload
  );
  console.log(res, "res");
  if (res?.status && res?.data) {
    const data = res?.data?.tableMaster;
    yield put(actions.saveEditTableMasterFormData(data));
  }
}
function* postEditTableMasterFormData(action) {
  console.log("yessssssssss");
  const res = yield call(
    settingServices.postEditTableMasterFormData,
    action.payload
  );
  console.log(res, "resaaa");
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.saveTableMasterData(data));
    yield put(
      actions.setFormState({
        formName: "table_master_form_state",
        formState: false,
      })
    );
  }
}
function* postAddRoomInForm(action) {
  const res = yield call(settingServices.postAddRoomInForm, action.payload);
  console.log(res, "res");
  if (res?.status && res?.data) {
    const data = res?.data?.rooms;
    yield put(actions.getTableMasterFormData());
  }
}

// Hardware Master
function* getHardwareMasterData(action) {
  const res = yield call(
    settingServices?.getHardwareMasterData,
    action?.payload
  );
  console.log(res, "res");
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.saveHardwareMasterData(data));
  }
}
function* postHardwareMasterData(action) {
  const res = yield call(
    settingServices?.postHardwareMasterData,
    action?.payload
  );
  console.log(res, "res");
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.saveHardwareMasterData(data));
    yield put(actions.getHardwareMasterFormData());
  }
}
function* getHardwareMasterFormData(action) {
  const res = yield call(
    settingServices?.getHardwareMasterFormData,
    action?.payload
  );
  console.log(res, "formmmmm");
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.saveHardwareMasterFormData(data));
  }
}
function* getQualificationSelection(action) {
  const res = yield call(
    settingServices?.getQualificationSelection,
    action?.payload
  );
  console.log(res, "resllll");
  if (res?.status && res?.data) {
    const data = res?.data.cat_val;
    yield put(actions.saveQualificationSelection(data));
  }
}
function* getEditHardwareMasterData(action) {
  const res = yield call(
    settingServices?.getEditHardwareMasterData,
    action?.payload
  );
  const qualification_level_id = res?.data?.tableMaster?.qualification_level_id;
  console.log(res, "reslllla");
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.saveEditHardwareMasterData(data));
    if (qualification_level_id) {
      yield put(actions?.getQualificationSelection(qualification_level_id));
    }
  }
}
function* postEditHardwareMasterData(action) {
  const res = yield call(
    settingServices?.postEditHardwareMasterData,
    action?.payload
  );
  console.log(res, "abcdef");
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.saveHardwareMasterData(data));
  }
}

function* getHardwareDetailsSession(action) {
  const res = yield call(
    settingServices?.getHardwareDetailsSession,
    action?.payload
  );

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.saveHardwareDetailsSession(data));
  }
}
function* postHardwareDetailsSession(action) {
  const res = yield call(
    settingServices?.postHardwareDetailsSession,
    action?.payload
  );

  console.log(res, "abcdef");
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.saveHardwareDetailsSession(data));
    yield put(
      actions.setModalState({
        modalName: "hardware_modal_state",
        modalState: false,
      })
    );
  }
}

// Inventory
function* getInventoryGeneralSettingsData(action) {
  const res = yield call(
    settingServices?.getInventoryGeneralSettingsData,
    action?.payload
  );

  console.log(res, "abcdef");
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.saveInventoryGeneralSettingsData(data));
  }
}

function* postInventoryGeneralSettingsData(action) {
  const res = yield call(
    settingServices?.postInventoryGeneralSettingsData,
    action?.payload
  );

  console.log(res, "abcdef");
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.saveInventoryGeneralSettingsData(data));
  }
}

function* getInventoryCountSettingsData(action) {
  const res = yield call(
    settingServices?.getInventoryCountSettingsData,
    action?.payload
  );

  console.log(res, "abcdef");
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.saveInventoryCountSettingsData(data));
  }
}

function* postAddInventoryCountSettingsData(action) {
  const res = yield call(
    settingServices?.postAddInventoryCountSettingsData,
    action?.payload
  );

  console.log(res, "abcdef");
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.saveInventoryCountSettingsData(data));

    yield put(
      actions.setModalState({
        modalName: "inventory_item_modal_state",
        modalState: false,
      })
    );
  }
}
function* postGeneralCountSettings(action) {
  const res = yield call(
    settingServices?.postGeneralCountSettings,
    action?.payload
  );

  console.log(res, "abcdef");
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.saveInventoryCountSettingsData(data));
  }
}

function* deleteInventoryCountSettingsData(action) {
  const res = yield call(
    settingServices?.deleteInventoryCountSettingsData,
    action?.payload
  );

  console.log(res, "abcdef");
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.saveInventoryCountSettingsData(data));
  }
}

function* getEditInventoryCountSettingsData(action) {
  const res = yield call(
    settingServices?.getEditInventoryCountSettingsData,
    action?.payload
  );

  console.log(res, "abcdef");
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.saveEditInventoryCountSettingsData(data));
  }
}

function* postEditInventoryCountSettingsData(action) {
  const res = yield call(
    settingServices?.postEditInventoryCountSettingsData,
    action?.payload
  );

  console.log(res, "abcdef");
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.saveInventoryCountSettingsData(data));
  }
}

// labour --> add form
function* getLabourAddEmployeeFormData(action) {
  const res = yield call(
    settingServices?.getLabourAddEmployeeFormData,
    action?.payload
  );
  console.log("in getLabour Form data");

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.saveLabourAddEmployeeFormData(data));
    // yield put(actions.getEmployeeBankingInfo());
  }
}
function* postLabourAddEmployeeFormData(action) {
  const res = yield call(
    settingServices?.postLabourAddEmployeeFormData,
    action?.payload
  );

  console.log(res, "abcdef");
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.saveLabourEmployeeList(data));
    yield put(
      actions.setFormState({
        formName: "labour_employee_form_state",
        formState: false,
      })
    );
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "success"));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}

function* getLabourEmployeeList(action) {
  const res = yield call(
    settingServices?.getLabourEmployeeList,
    action?.payload
  );

  console.log(res, "abcdef");
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.saveLabourEmployeeList(data));
  }
}

function* getEditLabourEmployeeData(action) {
  // yield put(actions.getLabourAddEmployeeFormData());

  const res = yield call(
    settingServices?.getEditLabourEmployeeData,
    action?.payload
  );

  console.log("in getEdit labour");
  if (res?.status && res?.data) {
    const data = res?.data?.emp_data;
    yield put(actions.saveEditLabourEmployeeData(data));
    yield put(actions.getEmployeeTaxDocumentInfo());
    yield put(actions.getEmployeeDocumentInfo());
    yield put(actions.getEmployeeDependentsInfo());
    yield put(actions.getEmployeeBankingInfo());
    yield put(
      actions.setFormState({
        formName: "labour_employee_form_state",
        formState: true,
      })
    );
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}

function* postEditLabourEmployeeData(action) {
  const res = yield call(
    settingServices?.postEditLabourEmployeeData,
    action?.payload
  );

  console.log(res, "abcdef");
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.saveLabourEmployeeList(data));
    yield put(
      actions.setFormState({
        formName: "labour_employee_form_state",
        formState: false,
      })
    );
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "success"));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}
function* getEmployeeBankingInfo(action) {
  const res = yield call(
    settingServices?.getEmployeeBankingInfo,
    action?.payload
  );
  if (res?.status && res?.data) {
    const data = res?.data?.employees;
    yield put(actions.saveEmployeeBankingInfo(data));

    // yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "success"));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}
function* postEmployeeBankingInfo(action) {
  const res = yield call(
    settingServices?.postEmployeeBankingInfo,
    action?.payload
  );

  if (res?.status && res?.data) {
    const data = res?.data?.employees;
    yield put(actions.saveEmployeeBankingInfo(data));
    yield put(
      actions.setFormState({
        formName: "labour_employee_add_banking_modal_state",
        formState: false,
      })
    );
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "success"));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}
function* deleteEmployeeBankingInfo(action) {
  const res = yield call(
    settingServices?.deleteEmployeeBankingInfo,
    action?.payload
  );

  if (res?.status && res?.data) {
    const data = res?.data?.employees;
    console.log(data, "bankingInfo");
    yield put(actions.saveEmployeeBankingInfo(data));

    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "success"));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}
function* getEmployeeDocumentInfo(action) {
  const res = yield call(
    settingServices?.getEmployeeDocumentInfo,
    action?.payload
  );
  if (res?.status && res?.data) {
    const data = res?.data?.documents;
    yield put(actions.saveEmployeeDocumentInfo(data));

    // yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "success"));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}
function* postEmployeeDocumentInfo(action) {
  const res = yield call(
    settingServices?.postEmployeeDocumentInfo,
    action?.payload
  );

  if (res?.status && res?.data) {
    const data = res?.data?.documents;
    yield put(actions.saveEmployeeDocumentInfo(data));
    yield put(
      actions.setFormState({
        formName: "labour_employee_add_document_modal_state",
        formState: false,
      })
    );
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "success"));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}
function* deleteEmployeeDocumentInfo(action) {
  const res = yield call(
    settingServices?.deleteEmployeeDocumentInfo,
    action?.payload
  );

  if (res?.status && res?.data) {
    const data = res?.data?.documents;
    console.log(data, "documents");
    yield put(actions.saveEmployeeDocumentInfo(data));

    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "success"));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}

function* getEmployeeTaxDocumentInfo(action) {
  const res = yield call(
    settingServices?.getEmployeeTaxDocumentInfo,
    action?.payload
  );
  if (res?.status && res?.data) {
    const data = res?.data?.documents;
    yield put(actions.saveEmployeeTaxDocumentInfo(data));

    // yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "success"));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}
function* postEmployeeTaxDocumentInfo(action) {
  const res = yield call(
    settingServices?.postEmployeeTaxDocumentInfo,
    action?.payload
  );

  if (res?.status && res?.data) {
    const data = res?.data?.documents;
    yield put(actions.saveEmployeeTaxDocumentInfo(data));
    yield put(
      actions.setFormState({
        formName: "labour_employee_add_tax_document_modal_state",
        formState: false,
      })
    );
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "success"));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}
function* deleteEmployeeTaxDocumentInfo(action) {
  const res = yield call(
    settingServices?.deleteEmployeeTaxDocumentInfo,
    action?.payload
  );

  if (res?.status && res?.data) {
    const data = res?.data?.documents;
    console.log(data, "documents");
    yield put(actions.saveEmployeeTaxDocumentInfo(data));

    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "success"));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}

function* getEmployeeDependentsInfo(action) {
  const res = yield call(
    settingServices?.getEmployeeDependentsInfo,
    action?.payload
  );
  if (res?.status && res?.data) {
    const data = res?.data?.dependents;
    yield put(actions.saveEmployeeDependentsInfo(data));

    // yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "success"));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}
function* postEmployeeDependentsInfo(action) {
  const res = yield call(
    settingServices?.postEmployeeDependentsInfo,
    action?.payload
  );

  if (res?.status && res?.data) {
    const data = res?.data?.dependents;
    yield put(actions.saveEmployeeDependentsInfo(data));
    yield put(
      actions.setFormState({
        formName: "labour_employee_dependents_modal_state",
        formState: false,
      })
    );
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "success"));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}
function* deleteEmployeeDependentsInfo(action) {
  const res = yield call(
    settingServices?.deleteEmployeeDependentsInfo,
    action?.payload
  );

  if (res?.status && res?.data) {
    const data = res?.data?.dependents;
    console.log(data, "dependents");
    yield put(actions.saveEmployeeDependentsInfo(data));

    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "success"));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}

function* getClipBoardData(action) {
  const res = yield call(settingServices?.getClipBoardData, action?.payload);
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.saveClipBoardData(data));

    // yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "success"));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}
function* postClipBoardData(action) {
  const res = yield call(settingServices?.postClipBoardData, action?.payload);

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.saveClipBoardData(data));
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "success"));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}
function* postClipBoardDescription(action) {
  const res = yield call(
    settingServices?.postClipBoardDescription,
    action?.payload
  );

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.saveClipBoardData(data));
    yield put(
      actions.setFormState({
        formName: "clipboard_checklist_modal_state",
        formState: false,
      })
    );
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "success"));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}
function* deleteClipBoardDescription(action) {
  const res = yield call(
    settingServices?.deleteClipBoardDescription,
    action?.payload
  );

  if (res?.status && res?.data) {
    const data = res?.data;
    console.log(data, "dependents");
    yield put(actions.saveClipBoardData(data));

    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "success"));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}

function* getPromotions(action) {
  const res = yield call(settingServices?.getPromotions, action?.payload);
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.savePromotions(data));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}
function* deletePromotion(action) {
  const res = yield call(settingServices?.deletePromotion, action?.payload);

  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.savePromotions(data));

    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "success"));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}
function* getPromotionsFormData(action) {
  const res = yield call(
    settingServices?.getPromotionsFormData,
    action?.payload
  );
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.savePromotionsFormData(data));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}
function* postAddPromotionData(action) {
  const res = yield call(
    settingServices?.postAddPromotionData,
    action?.payload
  );
  if (res?.status && res?.data) {
    const data = res?.data;
    action?.payload?.historyFunc.push("/menu/promotions");
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "success"));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}
function* postPromotionApplicationData(action) {
  const res = yield call(
    settingServices?.postPromotionApplicationData,
    action?.payload
  );
  if (res?.status && res?.data) {
    const data = res?.data?.periods;
    yield put(actions.savePromotionApplicationData(data));
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "success"));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}

function* getEditPromotionData(action) {
  const res = yield call(
    settingServices?.getEditPromotionData,
    action?.payload
  );
  if (res?.status && res?.data) {
    const data = res?.data?.pos_promotion;
    yield put(actions.saveEditPromotionData(data));
    yield put(actions.savePromotionPeriod(data?.pos_promotion_period));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}
function* postEditPromotionData(action) {
  const res = yield call(
    settingServices?.postEditPromotionData,
    action?.payload
  );
  if (res?.status && res?.data) {
    const data = res?.data;
    action?.payload?.historyFunc.push("/menu/promotions");
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "success"));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}

function* postPromoGroup(action) {
  const res = yield call(settingServices?.postPromoGroup, action?.payload);
  if (res?.status && res?.data) {
    const data = res?.data?.promo_groups;
    yield put(actions.savePromoGroup(data));
    yield put(
      actions.setModalState({
        modalName: "add_promo_modal_state",
        modalState: false,
      })
    );
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "success"));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}
function* editPromotionPeriod(action) {
  const res = yield call(settingServices?.editPromotionPeriod, action?.payload);
  if (res?.status && res?.data) {
    const data = res?.data?.pos_promotion_period;
    yield put(actions.savePromotionPeriod(data));
    yield put(
      actions?.setModalState({
        modalName: "promotion_period_modal_state",
        modalState: false,
      })
    );
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}
function* addPromotionPeriod(action) {
  const res = yield call(settingServices?.addPromotionPeriod, action?.payload);
  if (res?.status && res?.data) {
    const res = yield call(settingServices?.getAddPromotionPeriodData);
    const data = res?.data?.periods;
    yield put(actions.savePromotionPeriod(data));
    yield put(
      actions?.setModalState({
        modalName: "promotion_period_modal_state",
        modalState: false,
      })
    );
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}
function* deletePromotionPeriod(action) {
  const res = yield call(
    settingServices?.deletePromotionPeriod,
    action?.payload
  );
  if (res?.status && res?.data) {
    let data = yield select((state) => state?.settingReducer?.promotionPeriod);
    data = data?.filter((el) => el?.id !== action?.payload?.id);
    console.log(data, "bbbbbbb");
    yield put(actions.savePromotionPeriod(data));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}
function* getQualificationCriteria(action) {
  const res = yield call(
    settingServices?.getQualificationCriteria,
    action?.payload
  );
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.saveQualificationCriteria(data));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}
function* postQualificationCriteria(action) {
  const res = yield call(
    settingServices?.postQualificationCriteria,
    action?.payload
  );
  if (res?.status && res?.data) {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "success"));
    yield put(
      actions?.setModalState({
        modalName: "qualification_modal_state",
        modalState: false,
      })
    );
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}
function* getQrOrderData(action) {
  const res = yield call(settingServices?.getQrOrderData, action?.payload);
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.saveQrOrderData(data));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}

function* postQrOrderData(action) {
  const res = yield call(settingServices?.postQrOrderData, action?.payload);
  if (res?.status && res?.data) {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "success"));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}

function* postPdfMenu(action) {
  const res = yield call(settingServices?.postPdfMenu, action?.payload);
  if (res?.status && res?.data) {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "success"));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}
function* editPostPdfMenuData(action) {
  console.log(action?.payload?.id, "oooooppppppp");
  const res = yield call(settingServices?.editPostPdfMenuData, action?.payload);
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "success"));
    yield put(actions?.saveUpdatedPdfMenu(data));
    yield put(
      actions?.setModalState({
        modalName: "pdfMenuModal",
        modalState: false,
      })
    );
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}

function* getMenuSequencingData(action) {
  const res = yield call(
    settingServices?.getMenuSequencingData,
    action?.payload
  );
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.saveMenuSequencingData(data));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}

function* postMenuSequencingData(action) {
  const res = yield call(
    settingServices?.postMenuSequencingData,
    action?.payload
  );
  if (res?.status && res?.data) {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "success"));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}
function* getQrList(action) {
  const res = yield call(settingServices?.getQrList, action?.payload);
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.saveQrList(data));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}
function* downloadQrList(action) {
  const res = yield call(settingServices?.downloadQrList, action?.payload);
  if (res?.status && res?.data) {
    const url = res?.data?.zip_file;
    window.open(url, "_self");
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}
function* downloadSelectedQr(action) {
  const res = yield call(settingServices?.downloadSelectedQr, action?.payload);
  if (res?.status && res?.data) {
    const url = res?.data?.zip_file;
    window.open(url, "_self");
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}
function* regenerateSelectedQr(action) {
  const res = yield call(
    settingServices?.regenerateSelectedQr,
    action?.payload
  );
  if (res?.status && res?.data) {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "success"));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}

function* refreshTableQrCode(action) {
  const res = yield call(settingServices?.refreshTableQrCode, action?.payload);
  if (res?.status && res?.data) {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "success"));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}

function* getOrdrrOnlineMenuSequencingData(action) {
  const res = yield call(
    settingServices?.getOrdrrOnlineMenuSequencingData,
    action?.payload
  );
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.saveOrdrrOnlineMenuSequencingData(data));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}

function* postOrdrrOnlineMenuSequencingData(action) {
  const res = yield call(
    settingServices?.postOrdrrOnlineMenuSequencingData,
    action?.payload
  );
  if (res?.status && res?.data) {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "success"));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}

function* getOrdrrOnlineData(action) {
  const res = yield call(settingServices?.getOrdrrOnlineData, action?.payload);
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.saveOrdrrOnlineData(data));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}

function* postOrdrrOnlineData(action) {
  const res = yield call(settingServices?.postOrdrrOnlineData, action?.payload);
  if (res?.status && res?.data) {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "success"));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}

function* getDeliveryPartnerData(action) {
  const res = yield call(
    settingServices?.getDeliveryPartnerData,
    action?.payload
  );
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.saveDeliveryPartnerData(data));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}

function* postDeliveryPartnerData(action) {
  const res = yield call(
    settingServices?.postDeliveryPartnerData,
    action?.payload
  );
  if (res?.status && res?.data) {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "success"));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}
function* addDeliveryPartner(action) {
  const res = yield call(settingServices?.addDeliveryPartner, action?.payload);
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.saveDeliveryPartnerData(data));
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "success"));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}
function* editDeliveryPartner(action) {
  const res = yield call(settingServices?.editDeliveryPartner, action?.payload);
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.saveDeliveryPartnerData(data));
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "success"));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}
function* deleteDeliveryPartner(action) {
  const res = yield call(
    settingServices?.deleteDeliveryPartner,
    action?.payload
  );
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.saveDeliveryPartnerData(data));
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "success"));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}

function* getApiKeyListing(action) {
  const res = yield call(settingServices?.getApiKeyListing, action?.payload);
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.saveApiListing(data));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}

function* postConfirmPassword(action) {
  const res = yield call(settingServices?.postConfirmPassword, action?.payload);
  if (res?.status) {
    yield put(actions.saveConfirmPasswordStatus(res?.status));
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "success"));
  } else {
    yield put(actions.saveConfirmPasswordStatus(res?.status));
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
    yield put(
      actions?.setModalState({
        modalName: "confirm_pass_modal",
        modalState: false,
      })
    );
  }
}
function* postDeleteApiKey(action) {
  const res = yield call(settingServices?.postDeleteApiKey, action?.payload);
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.saveApiListing(data));
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "success"));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}
function* postGenerateApiKey(action) {
  const res = yield call(settingServices?.postGenerateApiKey, action?.payload);
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.saveApiListing(data));
    yield put(
      actions?.setModalState({
        modalName: "generate_api_key_modal",
        modalState: false,
      })
    );
    yield put(actions?.saveConfirmPasswordStatus(false));
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "success"));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}
function* getIntegrationData(action) {
  const res = yield call(settingServices?.getIntegrationData, action?.payload);
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.saveIntegrationData(data));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}
function* postPackageStatus(action) {
  const res = yield call(settingServices?.postPackageStatus, action?.payload);
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.saveIntegrationData(data));
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "success"));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}
function* getIntegrationEditData(action) {
  const res = yield call(
    settingServices?.getIntegrationEditData,
    action?.payload
  );
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(actions.saveIntegrationEditData(data));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}
function* postIntegrationEditData(action) {
  const res = yield call(
    settingServices?.postIntegrationEditData,
    action?.payload
  );
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "success"));
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}
function* postPauseStore(action) {
  const res = yield call(settingServices?.postPauseStore, action?.payload);
  if (res?.status && res?.data) {
    const data = res?.data;
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "success"));
    yield put(
      actions.setModalState({
        modalName: "pause_store_modal",
        modalState: false,
      })
    );
  } else {
    yield put(showNotificationWithTimeout(`${res?.message ?? ""}`, "error"));
  }
}

function* settingSaga() {
  // integration
  yield takeLatest(actionTypes.GET_API_KEY_LISTING, getApiKeyListing);
  yield takeLatest(actionTypes.POST_DELETE_API_KEY, postDeleteApiKey);
  yield takeLatest(actionTypes.POST_CONFIRM_PASSWORD, postConfirmPassword);
  yield takeLatest(actionTypes.POST_GENERATE_API_KEY, postGenerateApiKey);
  yield takeLatest(actionTypes.GET_INTEGRATION_DATA, getIntegrationData);
  yield takeLatest(actionTypes.POST_PACKAGE_STATUS, postPackageStatus);
  yield takeLatest(
    actionTypes.GET_INTEGRATION_EDIT_DATA,
    getIntegrationEditData
  );
  yield takeLatest(
    actionTypes.POST_INTEGRATION_EDIT_DATA,
    postIntegrationEditData
  );
  yield takeLatest(actionTypes.POST_PAUSE_STORE, postPauseStore);

  // qr order
  yield takeLatest(actionTypes.GET_QR_ORDER_DATA, getQrOrderData);
  yield takeLatest(actionTypes.POST_QR_ORDER_DATA, postQrOrderData);
  yield takeLatest(actionTypes.POST_PDF_MENU, postPdfMenu);
  yield takeLatest(actionTypes.EDIT_POST_PDF_MENU_DATA, editPostPdfMenuData);

  yield takeLatest(actionTypes.GET_MENU_SEQUENCING_DATA, getMenuSequencingData);
  yield takeLatest(
    actionTypes.POST_MENU_SEQUENCING_DATA,
    postMenuSequencingData
  );
  yield takeLatest(actionTypes.GET_QR_LIST, getQrList);
  yield takeLatest(actionTypes.DOWNLOAD_QR_LIST, downloadQrList);
  yield takeLatest(actionTypes.DOWNLOAD_SELECTED_QR, downloadSelectedQr);
  yield takeLatest(actionTypes.REGENERATE_SELECTED_QR, regenerateSelectedQr);
  yield takeLatest(actionTypes.REFRESH_TABLE_QR_CODE, refreshTableQrCode);

  // ordrrOnline
  yield takeLatest(actionTypes.GET_ORDRR_ONLINE_DATA, getOrdrrOnlineData);
  yield takeLatest(actionTypes.POST_ORDRR_ONLINE_DATA, postOrdrrOnlineData);
  yield takeLatest(
    actionTypes.GET_ORDRR_ONLINE_MENU_SEQUENCING_DATA,
    getOrdrrOnlineMenuSequencingData
  );
  yield takeLatest(
    actionTypes.POST_ORDRR_ONLINE_MENU_SEQUENCING_DATA,
    postOrdrrOnlineMenuSequencingData
  );

  yield takeLatest(
    actionTypes.GET_DELIVERY_PARTNER_DATA,
    getDeliveryPartnerData
  );
  yield takeLatest(
    actionTypes.POST_DELIVERY_PARTNER_DATA,
    postDeliveryPartnerData
  );
  yield takeLatest(actionTypes.ADD_DELIVERY_PARTNER, addDeliveryPartner);
  yield takeLatest(actionTypes.EDIT_DELIVERY_PARTNER, editDeliveryPartner);
  yield takeLatest(actionTypes.DELETE_DELIVERY_PARTNER, deleteDeliveryPartner);

  // Promotions
  yield takeLatest(actionTypes.GET_PROMOTIONS, getPromotions);
  yield takeLatest(actionTypes.DELETE_PROMOTION, deletePromotion);

  yield takeLatest(actionTypes.GET_PROMOTIONS_FORM_DATA, getPromotionsFormData);
  yield takeLatest(actionTypes.POST_ADD_PROMOTION_DATA, postAddPromotionData);

  yield takeLatest(
    actionTypes.POST_PROMOTION_APPLICATION_DATA,
    postPromotionApplicationData
  );

  yield takeLatest(actionTypes.GET_EDIT_PROMOTION_DATA, getEditPromotionData);
  yield takeLatest(actionTypes.POST_EDIT_PROMOTION_DATA, postEditPromotionData);

  yield takeLatest(actionTypes.POST_PROMO_GROUP, postPromoGroup);
  yield takeLatest(actionTypes.EDIT_PROMOTION_PERIOD, editPromotionPeriod);
  yield takeLatest(actionTypes.ADD_PROMOTION_PERIOD, addPromotionPeriod);
  yield takeLatest(actionTypes.DELETE_PROMOTION_PERIOD, deletePromotionPeriod);
  yield takeLatest(
    actionTypes.GET_QUALIFICATION_CRITERIA,
    getQualificationCriteria
  );
  yield takeLatest(
    actionTypes.POST_QUALIFICATION_CRITERIA,
    postQualificationCriteria
  );

  // clipboard
  yield takeLatest(actionTypes.GET_CLIPBOARD_DATA, getClipBoardData);
  yield takeLatest(actionTypes.POST_CLIPBOARD_DATA, postClipBoardData);
  yield takeLatest(
    actionTypes.POST_CLIPBOARD_DESCRIPTION,
    postClipBoardDescription
  );
  yield takeLatest(
    actionTypes.DELETE_CLIPBOARD_DESCRIPTION,
    deleteClipBoardDescription
  );

  // Labour --> Add Form
  yield takeLatest(
    actionTypes.GET_LABOUR_ADD_EMPLOYEE_FORM_DATA,
    getLabourAddEmployeeFormData
  );
  yield takeLatest(
    actionTypes.POST_LABOUR_ADD_EMPLOYEE_FORM_DATA,
    postLabourAddEmployeeFormData
  );
  yield takeLatest(actionTypes.GET_LABOUR_EMPLOYEE_LIST, getLabourEmployeeList);
  yield takeLatest(
    actionTypes.GET_EDIT_LABOUR_EMPLOYEE_DATA,
    getEditLabourEmployeeData
  );
  yield takeLatest(
    actionTypes.POST_EDIT_LABOUR_EMPLOYEE_DATA,
    postEditLabourEmployeeData
  );
  yield takeLatest(
    actionTypes.GET_EMPLOYEE_BANKING_INFO,
    getEmployeeBankingInfo
  );
  yield takeLatest(
    actionTypes.POST_EMPLOYEE_BANKING_INFO,
    postEmployeeBankingInfo
  );
  yield takeLatest(
    actionTypes.DELETE_EMPLOYEE_BANKING_INFO,
    deleteEmployeeBankingInfo
  );

  yield takeLatest(
    actionTypes.GET_EMPLOYEE_DOCUMENT_INFO,
    getEmployeeDocumentInfo
  );

  yield takeLatest(
    actionTypes.POST_EMPLOYEE_DOCUMENT_INFO,
    postEmployeeDocumentInfo
  );
  yield takeLatest(
    actionTypes.DELETE_EMPLOYEE_DOCUMENT_INFO,
    deleteEmployeeDocumentInfo
  );

  yield takeLatest(
    actionTypes.GET_EMPLOYEE_TAX_DOCUMENT_INFO,
    getEmployeeTaxDocumentInfo
  );

  yield takeLatest(
    actionTypes.POST_EMPLOYEE_TAX_DOCUMENT_INFO,
    postEmployeeTaxDocumentInfo
  );
  yield takeLatest(
    actionTypes.DELETE_EMPLOYEE_TAX_DOCUMENT_INFO,
    deleteEmployeeTaxDocumentInfo
  );

  yield takeLatest(
    actionTypes.GET_EMPLOYEE_DEPENDENTS_INFO,
    getEmployeeDependentsInfo
  );

  yield takeLatest(
    actionTypes.POST_EMPLOYEE_DEPENDENTS_INFO,
    postEmployeeDependentsInfo
  );
  yield takeLatest(
    actionTypes.DELETE_EMPLOYEE_DEPENDENTS_INFO,
    deleteEmployeeDependentsInfo
  );

  // POS MASTER --> POS MASTER
  yield takeLatest(actionTypes.GET_POS_MASTER_DATA, getPosMasterData);
  yield takeLatest(
    actionTypes.POST_EDIT_POS_MASTER_FORM_DATA,
    postEditPosMasterFormData
  );
  yield takeLatest(
    actionTypes.POST_ADD_POS_MASTER_FORM_DATA,
    postAddPosMasterFormData
  );
  yield takeLatest(
    actionTypes.POST_POS_MASTER_ACTIVE_STATUS,
    postPosMasterActiveStatus
  );
  yield takeLatest(
    actionTypes.GET_POS_MASTER_FORM_OPTIONS,
    getPosMasterFormOptions
  );

  yield takeLatest(
    actionTypes.GET_EDIT_POS_MASTER_FORM_DATA,
    getEditPosMasterFormData
  );
  yield takeLatest(
    actionTypes.POST_POS_INTEGRATION_SETTING,
    postPosIntegrationSetting
  );
  yield takeLatest(actionTypes.GET_APPLICABLE_MODULE, getApplicableModule);
  yield takeLatest(actionTypes.GET_FREQUENCY, getFrequency);

  // POS MASTER --> LAYOUT MASTER
  yield takeLatest(actionTypes.GET_ROOMS_LAYOUT_DATA, getRoomsLayoutData);
  yield takeLatest(actionTypes.POST_ADD_ROOM_LAYOUT, postAddRoomLayout);
  yield takeLatest(actionTypes.POST_EDIT_ROOM_LAYOUT, postEditRoomLayout);
  yield takeLatest(actionTypes.GET_EDIT_ROOM_LAYOUT, getEditRoomLayout);
  yield takeLatest(actionTypes.DELETE_ROOM_LAYOUT, deleteRoomLayout);

  // POS MASTER --> TABLE MASTER
  yield takeLatest(actionTypes.GET_TABLE_MASTER_DATA, getTableMasterData);
  yield takeLatest(
    actionTypes.GET_TABLE_MASTER_FORM_DATA,
    getTableMasterFormData
  );
  yield takeLatest(
    actionTypes.POST_ADD_TABLE_MASTER_FORM_DATA,
    postAddTableMasterFormData
  );
  yield takeLatest(
    actionTypes.GET_EDIT_TABLE_MASTER_FORM_DATA,
    getEditTableMasterFormData
  );

  yield takeLatest(
    actionTypes.POST_EDIT_TABLE_MASTER_FORM_DATA,
    postEditTableMasterFormData
  );
  yield takeLatest(actionTypes.POST_ADD_ROOM_IN_FORM, postAddRoomInForm);

  // POS MASTER --> HARDWARE MASTER
  yield takeLatest(actionTypes.GET_HARDWARE_MASTER_DATA, getHardwareMasterData);
  yield takeLatest(
    actionTypes.POST_HARDWARE_MASTER_DATA,
    postHardwareMasterData
  );
  yield takeLatest(
    actionTypes.GET_HARDWARE_MASTER_FORM_DATA,
    getHardwareMasterFormData
  );
  yield takeLatest(
    actionTypes.GET_QUALIFICATION_SELECTION,
    getQualificationSelection
  );
  yield takeLatest(
    actionTypes.GET_EDIT_HARDWARE_MASTER_DATA,
    getEditHardwareMasterData
  );
  yield takeLatest(
    actionTypes.POST_EDIT_HARDWARE_MASTER_DATA,
    postEditHardwareMasterData
  );
  yield takeLatest(
    actionTypes.GET_HARDWARE_DETAILS_SESSION,
    getHardwareDetailsSession
  );
  yield takeLatest(
    actionTypes.POST_HARDWARE_DETAILS_SESSION,
    postHardwareDetailsSession
  );

  // Inventory
  yield takeLatest(
    actionTypes.GET_INVENTORY_GENERAL_SETTINGS_DATA,
    getInventoryGeneralSettingsData
  );

  yield takeLatest(
    actionTypes.POST_INVENTORY_GENERAL_SETTINGS_DATA,
    postInventoryGeneralSettingsData
  );
  yield takeLatest(
    actionTypes.GET_INVENTORY_COUNT_SETTINGS_DATA,
    getInventoryCountSettingsData
  );

  yield takeLatest(
    actionTypes.POST_ADD_INVENTORY_COUNT_SETTINGS_DATA,
    postAddInventoryCountSettingsData
  );
  yield takeLatest(
    actionTypes.POST_GENERAL_COUNT_SETTINGS,
    postGeneralCountSettings
  );
  yield takeLatest(
    actionTypes.DELETE_INVENTORY_COUNT_SETTINGS_DATA,
    deleteInventoryCountSettingsData
  );
  yield takeLatest(
    actionTypes.GET_EDIT_INVENTORY_COUNT_SETTINGS_DATA,
    getEditInventoryCountSettingsData
  );
  yield takeLatest(
    actionTypes.POST_EDIT_INVENTORY_COUNT_SETTINGS_DATA,
    postEditInventoryCountSettingsData
  );
  // onlife start

  yield takeLatest(actionTypes.GET_ON_LIFE_DATA, getOnlifeData);
  yield takeLatest(
    actionTypes.POST_MERCHANT_ON_LIFE_DATA,
    postMerchantOnlifeData
  );
  yield takeLatest(
    actionTypes.POST_COMPETITOR_ON_LIFE_DATA,
    postCompetitorOnlifeData
  );
  yield takeLatest(
    actionTypes.DELETE_COMPETITOR_ON_LIFE_DATA,
    deleteCompetitorOnlifeData
  );
  // onlife end

  yield takeLatest(actionTypes.ACCOUNT_SETTING_DETAILS, getAccountSetting);
  yield takeLatest(actionTypes.UPLOAD_ACC_LOGO, saveUploadAccLogo);
  yield takeLatest(actionTypes.COMPANY_SETTING_DETAILS, getCompanySetting);
  yield takeLatest(actionTypes.UPLOAD_ACC_DOCUMENT, saveUploadAccDocument);
  yield takeLatest(actionTypes.DELETE_ACC_DOCUMENT, deleteAccountingDocument);
  yield takeLatest(
    actionTypes.UPDATE_POSTING_PERIOD_STATUS,
    updateAccPeriodStatus
  );
  yield takeLatest(actionTypes.GET_COMPANY_NAME, getScheduleCompanyName);
  yield takeLatest(actionTypes.SCHEDULE_COMPANY_NAME, saveScheduleCompanyName);
  yield takeLatest(actionTypes.CODE_LIST_DETAILS, getCodeList);
  yield takeLatest(actionTypes.ADD_CODE_DETAILS, saveCodeData);
  yield takeLatest(actionTypes.DELETE_CODE_DETAILS, deleteCodeDetails);
  yield takeLatest(
    actionTypes.ACCOUNT_MANAGEMENT_DETAILS,
    getAccountManagement
  );
  yield takeLatest(
    actionTypes.SAVE_ACCOUNT_MANAGEMENT_DETAILS,
    saveAccountManagementData
  );
  yield takeLatest(actionTypes.UPDATE_ACCOUNT_ADMIN, updateAccountAdminData);
  yield takeLatest(actionTypes.UPDATE_PLAN_COST, updatePlanCostData);
  yield takeLatest(actionTypes.UPDATE_PLAN_TOPUP, updatePlanTopupData);
  yield takeLatest(actionTypes.UPDATE_POS_COUNT, updatePosCountData);
  yield takeLatest(actionTypes.GET_OWNER_SUBACC, getOwnerSubAccData);
  yield takeLatest(actionTypes.SAVE_PAYMENT_INFO, savePaymentInfoData);
  yield takeLatest(actionTypes.CANCEL_ACCOUNT, cancelAccountData);
  yield takeLatest(actionTypes.GET_INVOICE_LIST, getInvoiceListData);
  yield takeLatest(actionTypes.GET_INVOICE_DETAILS, getInvoiceDetailsData);
  yield takeLatest(actionTypes.GET_USER_MANAGE_DETAILS, getUserManagementData);
  yield takeLatest(actionTypes.GET_MERCHANT_USER_LIST, getMerchantUserListData);
  yield takeLatest(
    actionTypes.UPDATE_USER_MANAGE_DETAILS,
    updateUserManageData
  );
  yield takeLatest(actionTypes.ADD_LINKED_EMP, addLinkedEmployeeData);
  yield takeLatest(
    actionTypes.GET_PERMISSION_GROUP_LIST,
    getPermissionGroupListData
  );
  yield takeLatest(actionTypes.GET_CLUSTER_SETTINGS, getClusterSetting);
  yield takeLatest(actionTypes.ADD_CLUSTER_DETAILS, addClusterDetails);
  yield takeLatest(actionTypes.SAVE_CLUSTER_DETAILS, saveClusterdetails);
  yield takeLatest(actionTypes.GET_CLUSTER_MODULES, getClusterModules);
  yield takeLatest(actionTypes.ADD_CLUSTER_ACCESS, addClusterAccess);
  yield takeLatest(actionTypes.ADD_CLUSTER_STORE, addClusterStore);
  yield takeLatest(
    actionTypes.GET_FINANCE_GENERAL_SETTINGS,
    getFinanceGeneralDetails
  );
  yield takeLatest(
    actionTypes.SAVE_FINANCE_GENERAL_SETTINGS,
    saveFinanceGeneralDetails
  );
  yield takeLatest(
    actionTypes.GET_FINANCE_SALE_SETTINGS,
    getFinanceSaleDetails
  );
  yield takeLatest(actionTypes.SAVE_PAYMENT_METHOD, savePaymentMethodDetails);
  yield takeLatest(
    actionTypes.DELETE_PAYMENT_METHOD_ORDER,
    deletePaymentMethodDetails
  );
  yield takeLatest(
    actionTypes.UPDATE_PAYMENT_METHOD_ORDER,
    udpatePaymentMethodOrder
  );
  yield takeLatest(actionTypes.GET_GROUP_ACC_LIST, getGroupAccDetails);
  yield takeLatest(actionTypes.SAVE_SERVICE_PERIOD, saveServicePeriodDetails);
  yield takeLatest(actionTypes.SAVE_SALE_TYPE, saveSaleTypeDetails);
  yield takeLatest(
    actionTypes.DELETE_SERVICE_PERIOD,
    deleteServicePeriodDetails
  );
  yield takeLatest(actionTypes.DELETE_SALE_TYPE, deleteSaleTypeDetails);
  yield takeLatest(actionTypes.SAVE_SALE_GROUP, saveSaleGroupDetails);
  yield takeLatest(actionTypes.DELETE_SALE_GROUP, deleteSaleGroupDetails);
  yield takeLatest(actionTypes.SAVE_CHANNEL, saveChannelDetails);
  yield takeLatest(actionTypes.DELETE_CHANNEL, deleteChannelDetails);
  yield takeLatest(actionTypes.GET_PUBLIC_HOLIDAY, getPublicHolidayDetails);
  yield takeLatest(actionTypes.SAVE_PUBLIC_HOLIDAY, savePublicHolidayDetails);
  yield takeLatest(
    actionTypes.DELETE_PUBLIC_HOLIDAY,
    deletePublicHolidayDetails
  );
  yield takeLatest(actionTypes.UPDATE_MATRIX_FINANCE, updateMatrixSetting);
  yield takeLatest(actionTypes.GET_MASTER_SETTING, getMasterSettingDetails);
  yield takeLatest(
    actionTypes.SAVE_PM_MASTER_SETTING,
    savePmMasterSettingDetails
  );
  yield takeLatest(
    actionTypes.UPDATE_PM_MASTER_SETTING,
    updatePmMasterSettingDetails
  );
  yield takeLatest(
    actionTypes.UPDATE_PM_MASTER_SETTING_STATUS,
    updatePmMasterSettingStatusDetails
  );
  yield takeLatest(
    actionTypes.REFRESH_PM_MASTER_SETTING,
    refreshPmMasterSettingDetails
  );
  yield takeLatest(
    actionTypes.SAVE_SALES_MASTER_SETTING,
    saveSalesMasterSettingDetails
  );
  yield takeLatest(
    actionTypes.UPDATE_SALES_MASTER_SETTING,
    updateSalesMasterSettingDetails
  );
  yield takeLatest(
    actionTypes.UPDATE_SALES_MASTER_SETTING_STATUS,
    updateSalesMasterSettingStatusDetails
  );
  yield takeLatest(
    actionTypes.REFRESH_SALES_MASTER_SETTING,
    refreshSalesMasterSettingDetails
  );
  yield takeLatest(
    actionTypes.SAVE_SERVICE_PERIOD_MASTER_SETTING,
    saveServicePeriodsMasterSettingDetails
  );
  yield takeLatest(
    actionTypes.UPDATE_SERVICE_PERIOD_MASTER_SETTING,
    updateServicePeriodsMasterSettingDetails
  );
  yield takeLatest(
    actionTypes.UPDATE_SERVICE_PERIOD_MASTER_SETTING_STATUS,
    updateServicePeriodsMasterSettingStatusDetails
  );
  yield takeLatest(
    actionTypes.REFRESH_SERVICE_PERIOD_MASTER_SETTING,
    refreshServicePeriodsMasterSettingDetails
  );
  yield takeLatest(
    actionTypes.SAVE_CHANNELS_MASTER_SETTING,
    saveChannelsMasterSettingDetails
  );
  yield takeLatest(
    actionTypes.UPDATE_CHANNELS_MASTER_SETTING,
    updateChannelsMasterSettingDetails
  );
  yield takeLatest(
    actionTypes.UPDATE_CHANNELS_MASTER_SETTING_STATUS,
    updateChannelsMasterSettingStatusDetails
  );
  yield takeLatest(
    actionTypes.REFRESH_CHANNELS_MASTER_SETTING,
    refreshChannelsMasterSettingDetails
  );
  yield takeLatest(
    actionTypes.GET_FINANCE_CHARTS_OF_ACC_SETTINGS,
    getFinanceChartOfAccSettingDetails
  );
  yield takeLatest(actionTypes.GET_FINANCE_ACCOUNTS, getFinanceAccDetails);
  yield takeLatest(
    actionTypes.DOWNLOAD_ALL_FINANCE_ACCOUNTS,
    downloadAllFinanceAccDetail
  );
  yield takeLatest(actionTypes.ADD_FINANCE_ACCOUNTS, addFinanceAccDetail);
  yield takeLatest(
    actionTypes.ADD_FINANCE_SUB_ACCOUNTS,
    addFinanceSubAccDetail
  );
  yield takeLatest(
    actionTypes.SAVE_FINANCE_SUB_ACCOUNTS,
    saveFinanceSubAccDetail
  );
  yield takeLatest(
    actionTypes.GET_UPDATE_FINANCE_SUB_ACCOUNTS,
    getUpdateFinanceSubAccDetail
  );
  yield takeLatest(
    actionTypes.GET_SUB_ACCOUNT_TRANSACTIONS,
    getSubAccTransactionsDetails
  );
  yield takeLatest(actionTypes.SAVE_EDIT_SUB_ACCOUNT, saveEditSubAccDetail);
  yield takeLatest(
    actionTypes.GET_ADD_TRANS_SUB_ACCOUNTS,
    getAddTransSubAccDetail
  );
  yield takeEvery(
    actionTypes.GET_DEBIT_CREDIT_ACCOUNT,
    getDebitCreditAccDetails
  );
  yield takeLatest(actionTypes.SAVE_ACCOUNT_TRANSACTION, saveAccTransaction);
  yield takeLatest(
    actionTypes.GET_FINANCE_FORECAST_SETTINGS,
    getForecastSettingsDetail
  );
  yield takeLatest(actionTypes.GET_FORECAST_RULE, getForecastRulesDetail);
  yield takeLatest(
    actionTypes.SAVE_FINANCE_FORECAST_SETTINGS,
    saveForecastSettingsDetail
  );
  yield takeLatest(
    actionTypes.GET_APPLICABLE_QUARTER,
    getApplicableQuarterDetail
  );
  yield takeLatest(actionTypes.EDIT_FINANCE_RULE, editFinanceRuleDetail);
  yield takeLatest(actionTypes.UPDATE_FINANCE_RULE, updateFinanceRuleDetail);
  yield takeLatest(actionTypes.GET_RECONSILE_SETTINGS, getReconsileDetail);
  yield takeLatest(actionTypes.ADD_RECONSILE_SETTINGS, saveReconsileDetail);
  yield takeLatest(
    actionTypes.DELETE_RECONSILE_SETTINGS,
    deleteReconsileDetail
  );
  yield takeLatest(
    actionTypes.GET_RECONSILE_UPLOAD_SETTINGS,
    getReconsileUploadDetail
  );
  yield takeLatest(
    actionTypes.SAVE_RECONSILE_UPLOAD_SETTINGS,
    saveReconsileUploadDetail
  );
 
}

export default settingSaga;
